/* eslint-disable no-nested-ternary */
/* eslint-disable no-unused-vars */
/**
 * © [2022] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */
import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import TextField from '@material-ui/core/TextField';
import { Dropdown, Button, OverlayTrigger, Tooltip } from 'react-bootstrap';
import DateFnsUtils from '@date-io/date-fns';
import {
  MuiPickersUtilsProvider,
  KeyboardDatePicker,
} from '@material-ui/pickers';
import MenuItem from '@material-ui/core/MenuItem';
import _ from 'lodash';

import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import AppBar from '@material-ui/core/AppBar';
import moment from 'moment';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Checkbox from '@material-ui/core/Checkbox';
import Spinner from '../../../../SharedModules/Spinner/SpinnerNew';
import CustomSeparator from '../../../../SharedModules/Breadcrumbs/BreadcrumbsComponent';
import SVGComponent from '../../../../SharedModules/SVGComponents/SVGComponents';
import ErrorMessages from '../../../../SharedModules/Errors/ErrorMessages';
import * as AppConstants from '../../../../SharedModules/AppConstants';
import DisplaySuccessMessages from '../../../../SharedModules/Errors/SuccessMessage';
import CommentIcon from '../../../../assets/images/comment-dots.svg';
import CommentAndCorrespondenceComponent from '../../../../SharedModules/MicroFrontend/CommentAndCorrespondenceComponent';
import CommentVisibleIcon from '../../../../assets/images/commen-visible-icon.svg';
import * as actionType from './store/actionTypes';
import SaveCancelPopup from '../../../../SharedModules/CustomSaveCancelPopup/SaveCancelPopup';
import {
  removeErr,
  tabHighLigther,
  makeFormDirty,
  checkActionAccessByRole,
} from '../../../../SharedModules/utilities/utilities';
import {
  checkQuarterValidation,
  closeTab,
  compareQtrs,
  convertQuaterToDate,
  redirectURLLink,
} from '../../../../SharedModules/CommonUtilities/commonUtilities';
import CommonModal from '../../../../SharedModules/Dialog/CommonModal';
import TableGrid from '../../../../SharedModules/Table/TableGridWithFeatures';
import {
  onCellFocused,
  navigateToNextCell,
  tabToNextCell,
} from '../../../../SharedModules/AgGridUtilities/suppressNavigation';

import ViewHistoryComponent from '../../../../SharedModules/MicroFrontend/ViewHistoryComponent';
import {
  addTableRecord,
  auditTabDataCons,
  deleteTableRecord,
  EnrollmentPayload,
  fieldValidation,
  fieldValidationMsgs,
  getAuditPayload,
  getUnitAuditPayload,
  GroupPayload,
  IntSharePayload,
  mergeSysDefOverrides,
  pgmDetailsPayload,
  qtrHandler,
  tableFldBlurAction,
  URAPayload,
  uraTabValidation,
  intTabValidation,
  groupTabValidation,
  enrollTabValidation,
  unitTypeTabValidation,
  auditTabValidation,
  detailsInvoiceOverrideTabsValidations,
  defaultDataForAudits,
  cmsReportingChk,
  cmsUtilizationChk,
  intFedFamilyChk,
  intFedaralChk,
  intCalcChk,
  uraSourceChk,
  uraCalcChk,
  uraPayChk,
  uraPmryPayload,
  intPmryPayload,
  grpPmryPayload,
  enrollPmryPayload,
} from '../CommonTabAction';
import DetailsTab from '../DetailsTab';
import InvoiceDetailsTab from '../InvoiceDetailsTab';
import IntShareTab from '../IntShareTab';
import URATab from '../URATab';
import GroupTab from '../GroupTab';
import UnitTypeAuditTab from '../UnitTypeAuditTab';
import DefaultOverrideTab from '../DefaultOverrideTab';
import AuditsTabs from '../AuditsTab';
import EnrollmentTab from '../EnrollmentTab';
import {
  tabValue,
  errorMsg,
  fieldErr,
  getRebatePgmDetail,
  saveAPICall,
  defaultAuditCheck,
  saveEnable,
  copyData,
  pgmDetail,
  getLastFrozenQtr,
  getUraGridList,
  getIntGridList,
  getAuditGridList,
  getUnitTypeAuditGridList,
  getGroupGridData,
  getEnrollGridData,
  customReset,
  getCmsFreezeQtr,
  getMaxQtrEnroll,
  getUseDefAuditsInd,
  getOverrideDefaultData,
  getOverrideSystemData,
  getDefaultAuditValues,
  saveUpdateRebatePgm,
} from './store/actions';
import { getExistingCorrLinkIds } from '../store/actions';
import * as Constants from '../RebatePgmConstants';
import { SUCCESSMESSAGE_PRICE } from '../../../../SharedModules/Errors/constantMessageData';
import NumberFormatCustom from '../../../../SharedModules/NumberFormat/NumberFormat';

const MaintainRebate = () => {
  const dispatch = useDispatch();
  const history = useHistory();
  const { kcRoles } = useSelector((state) => state.sharedState.SharedReducer);
  const [load, setLoad] = React.useState(true);
  const [showComments, setShowComments] = React.useState(false);
  const [linkTable, setLinkTable] = React.useState('');
  const [corrLinkId, setCorrLinkId] = React.useState('');
  const [cancelView, setCancelView] = React.useState(false);
  const [saveView, setSaveView] = React.useState(false);
  // const [errorPopup, setErrorPopup] = React.useState(false);
  // const [errorMessage, setErrorMessage] = React.useState('');
  const [confimPopup, setConfimPopup] = React.useState(false);
  const capstyle = { textTransform: 'capitalize' };
  const [enrollParams, setEnrollParams] = React.useState();
  const [fullScreen, setFullScreen] = React.useState(false);
  const [saveMsg, setSaveMsg] = React.useState([]);
  const [closeFlag, setCloseFlag] = React.useState();
  const [showViewHistory, setShowViewHistory] = React.useState(false);
  const [keyValue, setKeyValue] = React.useState([]);
  const [tabFullSrn, setTabFullSrn] = React.useState(false);
  const [uraSrcErr, setUraSrcErr] = React.useState(false);
  const [uraCalcErr, setUraCalcErr] = React.useState(false);
  const [uraPayErr, setUraPayErr] = React.useState(false);
  const [intCalErr, setIntCalErr] = React.useState(false);
  const [intFederr, setIntFedErr] = React.useState(false);
  const [intFmlyErr, setIntFmlyErr] = React.useState(false);
  const [cmsRptErr, setCmsRptErr] = React.useState(false);
  const [cmsUtilErr, setCmsUtilErr] = React.useState(false);
  const [enrollErr, setEnrollErr] = React.useState(false);
  const [unitErr, setUnitErr] = React.useState(false);
  const [deleteModal, setDeleteModal] = React.useState(false);
  const [deleteInd, setDeleteInd] = React.useState(null);
  const [hasAccess, setHasAccess] = React.useState(
    checkActionAccessByRole(process.env.REACT_APP_HIDE_ACCESS_ROLES, kcRoles)
  );
  const [isEnablebyRole, setIsEnablebyRole] = React.useState(
    checkActionAccessByRole(process.env.REACT_APP_STATE_ONLY_ROLE, kcRoles)
  );
  const active_tab = useSelector(
    (state) => state?.sharedState?.MaintainRebateReducer?.active_tab
  );
  const err_msg = useSelector(
    (state) => state?.sharedState?.MaintainRebateReducer?.err_msg
  );
  const fld_err = useSelector(
    (state) => state?.sharedState?.MaintainRebateReducer?.fld_err
  );
  const pgm_detail = useSelector(
    (state) => state?.sharedState?.MaintainRebateReducer?.pgm_detail
  );
  const default_audit = useSelector(
    (state) => state?.sharedState?.MaintainRebateReducer?.default_audit
  );
  const save_disable = useSelector(
    (state) => state?.sharedState?.MaintainRebateReducer?.save_disable
  );
  const comment_flag = useSelector(
    (state) => state?.sharedState?.MaintainRebateReducer?.comment_flag
  );
  const ura_grid_data = useSelector(
    (state) => state?.sharedState?.MaintainRebateReducer?.ura_grid_data
  );
  const copy_ura_data = useSelector(
    (state) => state?.sharedState?.MaintainRebateReducer?.copy_ura_data
  );
  const last_frozen_qtr = useSelector(
    (state) => state?.sharedState?.MaintainRebateReducer?.last_frozen_qtr
  );
  const last_ura_src_calc_qtr = useSelector(
    (state) => state?.sharedState?.MaintainRebateReducer?.last_ura_src_calc_qtr
  );
  const copy_int_data = useSelector(
    (state) => state?.sharedState?.MaintainRebateReducer?.copy_int_data
  );
  const int_grid_data = useSelector(
    (state) => state?.sharedState?.MaintainRebateReducer?.int_grid_data
  );
  const override_data = useSelector(
    (state) => state?.sharedState?.MaintainRebateReducer?.override_data
  );
  const copy_unit_type_data = useSelector(
    (state) => state?.sharedState?.MaintainRebateReducer?.copy_unit_type_data
  );
  const unit_type_data = useSelector(
    (state) => state?.sharedState?.MaintainRebateReducer?.unit_type_data
  );
  const group_data = useSelector(
    (state) => state?.sharedState?.MaintainRebateReducer?.group_data
  );
  const copy_group_data = useSelector(
    (state) => state?.sharedState?.MaintainRebateReducer?.copy_group_data
  );
  const enroll_data = useSelector(
    (state) => state?.sharedState?.MaintainRebateReducer?.enroll_data
  );
  const copy_enroll_data = useSelector(
    (state) => state?.sharedState?.MaintainRebateReducer?.copy_enroll_data
  );
  const deleted_int_calc = useSelector(
    (state) => state?.sharedState?.MaintainRebateReducer?.deleted_int_calc
  );
  const deleted_int_fed = useSelector(
    (state) => state?.sharedState?.MaintainRebateReducer?.deleted_int_fed
  );
  const deleted_int_fed_fmly = useSelector(
    (state) => state?.sharedState?.MaintainRebateReducer?.deleted_int_fed_fmly
  );
  const deleted_ura_src = useSelector(
    (state) => state?.sharedState?.MaintainRebateReducer?.deleted_ura_src
  );
  const deleted_ura_calc = useSelector(
    (state) => state?.sharedState?.MaintainRebateReducer?.deleted_ura_calc
  );
  const deleted_ura_pay = useSelector(
    (state) => state?.sharedState?.MaintainRebateReducer?.deleted_ura_pay
  );
  const deleted_cms_rpt = useSelector(
    (state) => state?.sharedState?.MaintainRebateReducer?.deleted_cms_rpt
  );
  const deleted_cms_util = useSelector(
    (state) => state?.sharedState?.MaintainRebateReducer?.deleted_cms_util
  );
  const deleted_enroll = useSelector(
    (state) => state?.sharedState?.MaintainRebateReducer?.deleted_enroll
  );
  const cms_freeze_qtr = useSelector(
    (state) => state?.sharedState?.MaintainRebateReducer?.cms_freeze_qtr
  );
  const max_enroll_qtr = useSelector(
    (state) => state?.sharedState?.MaintainRebateReducer?.max_enroll_qtr
  );
  const def_override = useSelector(
    (state) => state?.sharedState?.MaintainRebateReducer?.def_override
  );
  const sys_override = useSelector(
    (state) => state?.sharedState?.MaintainRebateReducer?.sys_override
  );
  const copy_data = useSelector(
    (state) => state?.sharedState?.MaintainRebateReducer?.copy_data
  );
  const audit_grid_data = useSelector(
    (state) => state?.sharedState?.MaintainRebateReducer?.audit_grid_data
  );
  const copy_audit_data = useSelector(
    (state) => state?.sharedState?.MaintainRebateReducer?.copy_audit_data
  );
  const audit_data = useSelector(
    (state) => state?.sharedState?.MaintainRebateReducer?.audit_data
  );
  const save_info = useSelector(
    (state) => state?.sharedState?.MaintainRebateReducer?.save_info
  );
  const def_sys_aud = useSelector(
    (state) => state?.sharedState?.RebatePgmReducer?.def_sys_aud
  );
  const unit_type = useSelector(
    (state) => state?.sharedState?.RebatePgmReducer?.unit_type
  );
  const logInUser = useSelector(
    (state) => state?.sharedState?.SharedReducer?.logInUser
  );
  const makeItDirty = () => {
    dispatch(saveEnable(false));
    makeFormDirty(Constants.MAINTAIN_ROUTE, true);
  };

  const gridParamsSet = (params) => {
    setEnrollParams(params);
  };

  const handleFullScreen = (val) => {
    setFullScreen(val);
  };

  const changeHandler = (val, fld, check = false) => {
    let data = { ...pgm_detail };
    data[fld] = check ? (val === true ? 1 : 0) : val;
    if (fld === 'claimRebateProgramCd' && data.planTypeCd === 'SUPP') {
      dispatch(getUseDefAuditsInd(val));
      // dispatch(getAuditGridList(val));
      // dispatch(getUnitTypeAuditGridList(val));
    }

    if (fld === 'useDefSystemInd')
      data = mergeSysDefOverrides(data, data[fld], sys_override, def_override);
    dispatch(pgmDetail(data));
    makeItDirty();
  };

  const auditchangeHandler = (val, fld, check = false) => {
    const data = { ...audit_data };
    data[fld] = check ? (val === true ? 1 : 0) : val;
    dispatch({ type: actionType.CONS_AUDIT_DATA, payload: data });
    makeItDirty();
  };

  const blurHandler = (val, fld, cond = '') => {
    const { error, flderror, auditFldBlur } = fieldValidation(
      val,
      fld,
      err_msg,
      fld_err,
      cond
    );
    dispatch(errorMsg(error));
    dispatch(fieldErr(flderror));
    if (auditFldBlur) auditchangeHandler(parseFloat(val).toFixed(2), fld);

    if (
      fld === 'firstSummaryRptQtr' &&
      flderror?.firstSummaryRptQtrErr === false &&
      flderror?.firstSummaryRptQtrReqErr === false
    ) {
      changeHandler(val.toUpperCase(), 'firstSummaryRptQtr');
    }

    if (
      fld === 'lastQtrWithoutClaims' &&
      flderror?.lastQtrWithoutClaimsErr === false &&
      flderror?.lastQtrWithoutClaimsReqErr === false
    ) {
      changeHandler(val.toUpperCase(), 'lastQtrWithoutClaims');
    }

    if (
      fld === 'dramsInvoiceStartQtr' &&
      flderror?.dramsInvoiceStartQtrErr === false &&
      flderror?.dramsInvoiceStartQtrReqErr === false
    ) {
      changeHandler(val.toUpperCase(), 'dramsInvoiceStartQtr');
    }

    if (
      fld === 'defEarliestQtrForDrugDtls' &&
      flderror?.earlierQtrReqErr === false &&
      flderror?.earlierQtrQtrErr === false
    ) {
      changeHandler(val.toUpperCase(), 'defEarliestQtrForDrugDtls');
    }
  };

  const clearRebateDetails = () => {
    setCancelView(false);
    dispatch(saveEnable(true));
    makeFormDirty(Constants.MAINTAIN_ROUTE, false);
    dispatch(errorMsg([]));
    dispatch(fieldErr({}));
    const data = JSON.parse(copy_data);
    const chk = data.useDefAuditsInd === 1;
    dispatch(defaultAuditCheck(chk));
    dispatch(pgmDetail(data));
    if (copy_audit_data)
      dispatch({
        type: actionType.CONS_AUDIT_DATA,
        payload: JSON.parse(copy_audit_data),
      });
    dispatch({
      type: actionType.URA_GRID_DATA,
      payload: JSON.parse(copy_ura_data),
    });
    dispatch({
      type: actionType.INT_GRID_DATA,
      payload: JSON.parse(copy_int_data),
    });
    dispatch({
      type: actionType.GROUP_GRID_DATA,
      payload: JSON.parse(copy_group_data),
    });
    dispatch({ type: actionType.DELETED_CMS_UTIL, payload: [] });
    dispatch({ type: actionType.DELETED_CMS_RPT, payload: [] });
    dispatch({ type: actionType.DELETED_INT_FED_FMLY, payload: [] });
    dispatch({ type: actionType.DELETED_INT_FED, payload: [] });
    dispatch({ type: actionType.DELETED_INT_CALC, payload: [] });
    dispatch({ type: actionType.DELETED_URA_PAY, payload: [] });
    dispatch({ type: actionType.DELETED_URA_CALC, payload: [] });
    dispatch({ type: actionType.DELETED_URA_SOURCE, payload: [] });
    if (copy_unit_type_data)
      dispatch({
        type: actionType.UNIT_TYPE_AUDIT_GRID_DATA,
        payload: JSON.parse(copy_unit_type_data),
      });
    dispatch(getUnitTypeAuditGridList(pgm_detail.rebateProgramCd));
    if (pgm_detail.planTypeCd === 'SUPP' || pgm_detail.planTypeCd === 'COMM') {
      dispatch({
        type: actionType.ENROLL_GRID_DATA,
        payload: JSON.parse(copy_enroll_data),
      });
      dispatch({ type: actionType.DELETED_ENROLL, payload: [] });
    }
  };

  const saveValidation = () => {
    let errors = [];
    let fld = {};
    const pgm = detailsInvoiceOverrideTabsValidations(pgm_detail, true);
    if (pgm.error.length > 0) {
      errors = [...errors, ...pgm.error];
      fld = { ...fld, ...pgm.flderror };
    }
    const ura = uraTabValidation(ura_grid_data, last_frozen_qtr, active_tab);
    if (ura.err.length > 0) {
      errors = [...errors, ...ura.err];
      dispatch({ type: actionType.URA_GRID_DATA, payload: ura.rec });
    }
    const int = intTabValidation(int_grid_data, pgm_detail.planTypeCd);
    if (int.err.length > 0) {
      errors = [...errors, ...int.err];
      dispatch({ type: actionType.INT_GRID_DATA, payload: int.rec });
    }
    const group = groupTabValidation(group_data, cms_freeze_qtr);
    if (group.err.length > 0) {
      errors = [...errors, ...group.err];
      dispatch({ type: actionType.GROUP_GRID_DATA, payload: group.rec });
    }
    if (pgm_detail.planTypeCd === 'SUPP' || pgm_detail.planTypeCd === 'COMM') {
      const enroll = enrollTabValidation(enroll_data, max_enroll_qtr);
      if (enroll.err.length > 0) {
        errors = [...errors, ...enroll.err];
        dispatch({ type: actionType.ENROLL_GRID_DATA, payload: enroll.rec });
      }
    }
    const uniterr = unitTypeTabValidation(unit_type_data);
    if (uniterr.err.length > 0) {
      errors = [...errors, ...uniterr.err];
      dispatch({
        type: actionType.UNIT_TYPE_AUDIT_GRID_DATA,
        payload: uniterr.rec,
      });
    }
    const auditerr = auditTabValidation(audit_data);
    if (auditerr.err.length) {
      errors = [...errors, ...auditerr.err];
      fld = { ...fld, ...auditerr.flderr };
    }
    if (errors.length > 0) {
      dispatch(errorMsg(errors));
      dispatch(fieldErr(fld));
      return false;
    }
    return true;
  };

  const saveRebateDetails = (ev, close) => {
    setSaveView(false);
    setCloseFlag(close);
    setLoad(true);
    // if (close)
    //   setTimeout(() => closeTab(Constants.MAINTAIN_ROUTE, history), 2000);
    let audit = getAuditPayload(
      audit_data,
      pgm_detail.rebateProgramCd,
      logInUser
    );
    let unit = getUnitAuditPayload(
      unit_type_data,
      pgm_detail.rebateProgramCd,
      logInUser
    );
    if (pgm_detail.useDefAuditsInd === 1) {
      audit = { rpcParamTestVOList: [] };
      unit = { rpcParamTestUnitAuditVOList: [] };
    }
    const data = pgmDetailsPayload(pgm_detail, logInUser);
    const ura = URAPayload(
      ura_grid_data,
      deleted_ura_src,
      deleted_ura_calc,
      deleted_ura_pay,
      pgm_detail.rebateProgramCd,
      logInUser
    );
    const int = IntSharePayload(
      int_grid_data,
      deleted_int_calc,
      deleted_int_fed,
      deleted_int_fed_fmly,
      pgm_detail.rebateProgramCd,
      pgm_detail.planTypeCd,
      logInUser
    );
    const grp = GroupPayload(
      group_data,
      deleted_cms_rpt,
      deleted_cms_util,
      pgm_detail.rebateProgramCd,
      logInUser
    );
    let enroll = { rpcEnrollmentVOList: [] };
    if (pgm_detail.planTypeCd === 'SUPP' || pgm_detail.planTypeCd === 'COMM')
      enroll = EnrollmentPayload(
        enroll_data,
        deleted_enroll,
        pgm_detail.rebateProgramCd,
        logInUser
      );
    const payload = {
      ...data,
      ...ura,
      ...int,
      ...grp,
      ...audit,
      ...unit,
      ...enroll,
    };
    dispatch(saveAPICall(payload));
  };

  const uraRecordAdd = (table, grid, err) => {
    const data = grid ? { ...grid } : { ...ura_grid_data };
    const error = err ? [...err] : [...err_msg];
    if (table === 'src') {
      const newdata = uraSourceChk(data);
      if (newdata.err.length) {
        addFnErrHandler(newdata.err, error);
        dispatch({
          type: actionType.URA_GRID_DATA,
          payload: { ...data, rpcUraSource: newdata.newdata },
        });
        return;
      }
    }
    if (table === 'calc') {
      if (
        data.rpcUraSource.some((obj) => obj.rpcParamValue === 'CALC') === false
      )
        return;

      const newdata = uraCalcChk(data);
      if (newdata.err.length) {
        addFnErrHandler(newdata.err, error);
        dispatch({
          type: actionType.URA_GRID_DATA,
          payload: { ...data, rpcUraCal: newdata.newdata },
        });
        return;
      }
    }
    if (table === 'pay') {
      if (pgm_detail.planTypeCd === 'FD') return;

      const newdata = uraPayChk(data);
      if (newdata.err.length) {
        addFnErrHandler(newdata.err, error);
        dispatch({
          type: actionType.URA_GRID_DATA,
          payload: { ...data, rpcUrPayment: newdata.newdata },
        });
        return;
      }
    }
    const plan = pgm_detail.planTypeCd;
    // let data = { ...ura_grid_data };
    const uraData = addTableRecord(
      table,
      data,
      pgm_detail.rebateProgramCd,
      plan,
      logInUser
    );
    dispatch({ type: actionType.URA_GRID_DATA, payload: uraData });
    if (table === 'calc') {
      const err = removeErr(err_msg, [Constants.URA_CALC_REQ]);
      dispatch(errorMsg(err));
    }
    if (table === 'src') {
      const err = removeErr(err_msg, [Constants.URA_ERR]);
      dispatch(errorMsg(err));
    }
    makeItDirty();
  };

  const intRecordAdd = (table, grid, err) => {
    const data = grid ? { ...grid } : { ...int_grid_data };
    const error = err ? [...err] : [...err_msg];
    if (table === 'intcalc') {
      if (pgm_detail.planTypeCd === 'COMM') return;
      const newdata = intCalcChk(data);
      if (newdata.err.length) {
        addFnErrHandler(newdata.err, error);
        dispatch({
          type: actionType.INT_GRID_DATA,
          payload: { ...data, rpcParamVoIntShareIntCalList: newdata.newdata },
        });
        return;
      }
    }
    if (table === 'intfed') {
      if (pgm_detail.planTypeCd === 'COMM') return;
      const newdata = intFedaralChk(data);
      if (newdata.err.length) {
        addFnErrHandler(newdata.err, error);
        dispatch({
          type: actionType.INT_GRID_DATA,
          payload: {
            ...data,
            rpcCalcPctVOIntShareFedaralList: newdata.newdata,
          },
        });
        return;
      }
    }
    if (table === 'intfedfmly') {
      if (pgm_detail.planTypeCd === 'COMM') return;
      const newdata = intFedFamilyChk(data);
      if (newdata.err.length) {
        addFnErrHandler(newdata.err, error);
        dispatch({
          type: actionType.INT_GRID_DATA,
          payload: {
            ...data,
            rpcParamVoIntShareFedaralFamiliList: newdata.newdata,
          },
        });
        return;
      }
    }
    // let data = { ...int_grid_data };
    const intData = addTableRecord(
      table,
      data,
      pgm_detail.rebateProgramCd,
      pgm_detail.planTypeCd,
      logInUser
    );
    dispatch({ type: actionType.INT_GRID_DATA, payload: intData });
    makeItDirty();
  };

  const grpRecordAdd = (table, grid, err) => {
    const data = grid ? { ...grid } : { ...group_data };
    const error = err ? [...err] : [...err_msg];
    if (table === 'cmsrpt') {
      const newdata = cmsReportingChk(data, cms_freeze_qtr);
      if (newdata.err.length) {
        addFnErrHandler(newdata.err, error);
        dispatch({
          type: actionType.GROUP_GRID_DATA,
          payload: { ...data, cmsReporting: newdata.newdata },
        });
        return;
      }
    }
    if (table === 'cmsutil') {
      const newdata = cmsUtilizationChk(data, cms_freeze_qtr);
      if (newdata.err.length) {
        addFnErrHandler(newdata.err, error);
        dispatch({
          type: actionType.GROUP_GRID_DATA,
          payload: { ...data, cmsUtilization: newdata.newdata },
        });
        return;
      }
    }
    // let data = { ...group_data };
    const grpData = addTableRecord(
      table,
      data,
      pgm_detail.rebateProgramCd,
      pgm_detail.planTypeCd,
      logInUser
    );
    dispatch({ type: actionType.GROUP_GRID_DATA, payload: grpData });
    makeItDirty();
  };

  const enrollRecordAdd = (grid, err) => {
    const data = grid ? [...grid] : [...enroll_data];
    const error = err ? [...err] : [...err_msg];
    const newData = enrollTabValidation(data, max_enroll_qtr);
    if (newData.err.length) {
      dispatch({ type: actionType.ENROLL_GRID_DATA, payload: newData.rec });
      addFnErrHandler(newData.err, error);
      return;
    }
    const grpData = addTableRecord(
      'roll',
      data,
      pgm_detail.rebateProgramCd,
      pgm_detail.planTypeCd,
      logInUser
    );
    dispatch({ type: actionType.ENROLL_GRID_DATA, payload: grpData });
    makeItDirty();
  };

  const addFnErrHandler = (errors, list) => {
    let err = removeErr(list, errors);
    err = [...err, ...errors];
    dispatch(errorMsg(err));
  };

  const deleteFromTable = () => {
    setDeleteModal(false);
    const indx = deleteInd.data.node.rowIndex;
    let err = [...err_msg];
    const deletedOld = !deleteInd.data.data.newFlag;
    if (deleteInd.table === 'src') {
      const rec = deleteInd.grid.rpcUraSource.filter((ob, ind) => ind !== indx);
      if (deletedOld)
        dispatch({
          type: actionType.DELETED_URA_SOURCE,
          payload: [...deleted_ura_src, deleteInd.data.data],
        });
      err = removeErr(err_msg, [deleteInd.data.data.startQtrMsg]);
      if (rec.length === 0) {
        const calcOld = deleteInd.grid.rpcUraCal.filter((o) => !o.newFlag);
        const cerr = [
          ...deleteInd.grid.rpcUraCal.map((o) => o.effectiveQtrMsg),
          ...deleteInd.grid.rpcUraCal.map((o) => o.calcMethodCdMsg),
          ...deleteInd.grid.rpcUraCal.map((o) => o.calcGenericPctMsg),
          ...deleteInd.grid.rpcUraCal.map((o) => o.calcFixedPctMsg),
        ];
        err = removeErr(err, cerr);
        dispatch(errorMsg(err));
        dispatch({
          type: actionType.DELETED_URA_CALC,
          payload: [...deleted_ura_calc, ...calcOld],
        });
        dispatch({
          type: actionType.URA_GRID_DATA,
          payload: { ...deleteInd.grid, rpcUraSource: rec, rpcUraCal: [] },
        });
        return;
      }
      dispatch({
        type: actionType.URA_GRID_DATA,
        payload: { ...deleteInd.grid, rpcUraSource: rec },
      });
    }
    if (deleteInd.table === 'calc') {
      const rec = deleteInd.grid.rpcUraCal.filter((ob, ind) => ind !== indx);
      if (deletedOld)
        dispatch({
          type: actionType.DELETED_URA_CALC,
          payload: [...deleted_ura_calc, deleteInd.data.data],
        });
      err = removeErr(err_msg, [
        deleteInd.data.data.effectiveQtrMsg,
        deleteInd.data.data.calcMethodCdMsg,
        deleteInd.data.data.calcGenericPctMsg,
        deleteInd.data.data.calcFixedPctMsg,
      ]);
      dispatch({
        type: actionType.URA_GRID_DATA,
        payload: { ...deleteInd.grid, rpcUraCal: rec },
      });
    }
    if (deleteInd.table === 'pay') {
      const rec = deleteInd.grid.rpcUrPayment.filter((ob, ind) => ind !== indx);
      if (deletedOld)
        dispatch({
          type: actionType.DELETED_URA_PAY,
          payload: [...deleted_ura_pay, deleteInd.data.data],
        });
      err = removeErr(err_msg, [deleteInd.data.data.startQtrMsg]);
      dispatch({
        type: actionType.URA_GRID_DATA,
        payload: { ...deleteInd.grid, rpcUrPayment: rec },
      });
    }
    if (deleteInd.table === 'intcalc') {
      const rec = deleteInd.grid.rpcParamVoIntShareIntCalList.filter(
        (ob, ind) => ind !== indx
      );
      if (deletedOld)
        dispatch({
          type: actionType.DELETED_INT_CALC,
          payload: [...deleted_int_calc, deleteInd.data.data],
        });
      err = removeErr(err_msg, [
        deleteInd.data.data.effectiveQtrMsg,
        deleteInd.data.data.calcMethodCdMsg,
        deleteInd.data.data.calcFixedPctMsg,
      ]);
      dispatch({
        type: actionType.INT_GRID_DATA,
        payload: { ...deleteInd.grid, rpcParamVoIntShareIntCalList: rec },
      });
    }
    if (deleteInd.table === 'intfed') {
      const rec = deleteInd.grid.rpcCalcPctVOIntShareFedaralList.filter(
        (ob, ind) => ind !== indx
      );
      if (deletedOld)
        dispatch({
          type: actionType.DELETED_INT_FED,
          payload: [...deleted_int_fed, deleteInd.data.data],
        });
      err = removeErr(err_msg, [
        deleteInd.data.data.startQtrMsg,
        deleteInd.data.data.rpcParamValueMsg,
      ]);
      dispatch({
        type: actionType.INT_GRID_DATA,
        payload: { ...deleteInd.grid, rpcCalcPctVOIntShareFedaralList: rec },
      });
    }
    if (deleteInd.table === 'intfedfmly') {
      const rec = deleteInd.grid.rpcParamVoIntShareFedaralFamiliList.filter(
        (ob, ind) => ind !== indx
      );
      if (deletedOld)
        dispatch({
          type: actionType.DELETED_INT_FED_FMLY,
          payload: [...deleted_int_fed_fmly, deleteInd.data.data],
        });
      err = removeErr(err_msg, [
        deleteInd.data.data.startQtrMsg,
        deleteInd.data.data.rpcParamValueMsg,
      ]);
      dispatch({
        type: actionType.INT_GRID_DATA,
        payload: {
          ...deleteInd.grid,
          rpcParamVoIntShareFedaralFamiliList: rec,
        },
      });
    }
    if (deleteInd.table === 'cmsrpt') {
      const rec = deleteInd.grid.cmsReporting.filter((ob, ind) => ind !== indx);
      if (deletedOld)
        dispatch({
          type: actionType.DELETED_CMS_RPT,
          payload: [...deleted_cms_rpt, deleteInd.data.data],
        });
      err = removeErr(err_msg, [
        deleteInd.data.data.startQtrMsg,
        deleteInd.data.data.endQtrMsg,
        deleteInd.data.data.cmsRptGroupNumMsg,
        deleteInd.data.data.cmsRptGroupNameMsg,
        deleteInd.data.data.cmsRptTitleMsg,
      ]);
      dispatch({
        type: actionType.GROUP_GRID_DATA,
        payload: { ...deleteInd.grid, cmsReporting: rec },
      });
    }
    if (deleteInd.table === 'cmsutil') {
      const rec = deleteInd.grid.cmsUtilization.filter(
        (ob, ind) => ind !== indx
      );
      if (deletedOld)
        dispatch({
          type: actionType.DELETED_CMS_UTIL,
          payload: [...deleted_cms_util, deleteInd.data.data],
        });
      err = removeErr(err_msg, [
        deleteInd.data.data.startQtrMsg,
        deleteInd.data.data.endQtrMsg,
        deleteInd.data.data.cmsUtilGroupNumMsg,
        deleteInd.data.data.cmsUtilGroupNameMsg,
      ]);
      dispatch({
        type: actionType.GROUP_GRID_DATA,
        payload: { ...deleteInd.grid, cmsUtilization: rec },
      });
    }
    if (deleteInd.table === 'enroll') {
      const rec = deleteInd.grid.filter((ob, ind) => ind !== indx);
      if (deletedOld)
        dispatch({
          type: actionType.DELETED_ENROLL,
          payload: [...deleted_enroll, deleteInd.data.data],
        });
      err = removeErr(err_msg, [
        deleteInd.data.data.qtrMsg,
        deleteInd.data.data.timingcdMsg,
      ]);
      dispatch({ type: actionType.ENROLL_GRID_DATA, payload: rec });
    }
    dispatch(errorMsg(err));
    setDeleteInd();
    makeItDirty();
  };

  // const uraRecordDelete = (table) => {
  //   let { err, tabledata, deletedOld } = deleteTableRecord(table, {
  //     ...ura_grid_data,
  //   });
  //   if (table === 'src')
  //     dispatch({
  //       type: actionType.DELETED_URA_SOURCE,
  //       payload: [...deleted_ura_src, ...deletedOld],
  //     });
  //   if (table === 'calc')
  //     dispatch({
  //       type: actionType.DELETED_URA_CALC,
  //       payload: [...deleted_ura_calc, ...deletedOld],
  //     });
  //   if (table === 'pay')
  //     dispatch({
  //       type: actionType.DELETED_URA_PAY,
  //       payload: [...deleted_ura_pay, ...deletedOld],
  //     });
  //   err = removeErr([...err_msg], err);
  //   dispatch(errorMsg(err));
  //   dispatch({ type: actionType.URA_GRID_DATA, payload: tabledata });
  //   makeItDirty();
  // };

  // const intRecordDelete = (table) => {
  //   let { err, tabledata, deletedOld } = deleteTableRecord(table, {
  //     ...int_grid_data,
  //   });
  //   if (table === 'intcalc')
  //     dispatch({
  //       type: actionType.DELETED_INT_CALC,
  //       payload: [...deleted_int_calc, ...deletedOld],
  //     });
  //   if (table === 'intfed')
  //     dispatch({
  //       type: actionType.DELETED_INT_FED,
  //       payload: [...deleted_int_fed, ...deletedOld],
  //     });
  //   if (table === 'intfedfmly')
  //     dispatch({
  //       type: actionType.DELETED_INT_FED_FMLY,
  //       payload: [...deleted_int_fed_fmly, ...deletedOld],
  //     });
  //   err = removeErr([...err_msg], err);
  //   dispatch(errorMsg(err));
  //   dispatch({ type: actionType.INT_GRID_DATA, payload: tabledata });
  //   makeItDirty();
  // };

  // const grpRecordDelete = (table) => {
  //   let { err, tabledata, deletedOld } = deleteTableRecord(table, {
  //     ...group_data,
  //   });
  //   if (table === 'cmsrpt')
  //     dispatch({
  //       type: actionType.DELETED_CMS_RPT,
  //       payload: [...deleted_cms_rpt, ...deletedOld],
  //     });
  //   if (table === 'cmsutil')
  //     dispatch({
  //       type: actionType.DELETED_CMS_UTIL,
  //       payload: [...deleted_cms_util, ...deletedOld],
  //     });
  //   err = removeErr([...err_msg], err);
  //   dispatch(errorMsg(err));
  //   dispatch({ type: actionType.GROUP_GRID_DATA, payload: tabledata });
  //   makeItDirty();
  // };

  // const enrollRecordDelete = () => {
  //   let { err, tabledata, deletedOld } = deleteTableRecord('roll', [
  //     ...enroll_data,
  //   ]);
  //   dispatch({
  //     type: actionType.DELETED_ENROLL,
  //     payload: [...deleted_enroll, ...deletedOld],
  //   });
  //   err = removeErr([...err_msg], err);
  //   dispatch(errorMsg(err));
  //   dispatch({ type: actionType.ENROLL_GRID_DATA, payload: tabledata });
  //   makeItDirty();
  // };

  const uraChangehandler = (val, prop, indx, table, record, blur, errmg) => {
    const tabdata = { ...record };
    let grid;
    if (table === 'src') grid = [...record.rpcUraSource];
    if (table === 'calc') grid = [...record.rpcUraCal];
    if (table === 'pay') grid = [...record.rpcUrPayment];
    const data = tableFldBlurAction(prop, table, val, indx, grid, blur, errmg);
    if (table === 'src') tabdata.rpcUraSource = data.newdata;
    if (table === 'calc') tabdata.rpcUraCal = data.newdata;
    if (table === 'pay') tabdata.rpcUrPayment = data.newdata;
    const li = tabdata.rpcUraSource.filter(
      (obj) => obj.rpcParamValue === 'CALC'
    );
    if (li.length === 0 && table === 'src' && prop === 'rpcParamValue') {
      const deletedOld = tabdata.rpcUraCal.filter((o) => !o.newFlag);
      let err = [
        ...tabdata.rpcUraCal.map((o) => o.effectiveQtrMsg),
        ...tabdata.rpcUraCal.map((o) => o.calcMethodCdMsg),
        ...tabdata.rpcUraCal.map((o) => o.calcGenericPctMsg),
        ...tabdata.rpcUraCal.map((o) => o.calcFixedPctMsg),
      ];
      err = removeErr(errmg, err);
      dispatch(errorMsg(err));
      dispatch({
        type: actionType.DELETED_URA_CALC,
        payload: [...deleted_ura_calc, ...deletedOld],
      });
      tabdata.rpcUraCal = [];
    }
    if (blur) dispatch(errorMsg(data.err));
    dispatch({ type: actionType.URA_GRID_DATA, payload: tabdata });
    makeItDirty();
  };

  const intChangehandler = (val, prop, indx, table, record, blur, errmg) => {
    const tabdata = { ...record };
    let grid;
    if (table === 'intcalc') grid = [...record.rpcParamVoIntShareIntCalList];
    if (table === 'intfed') grid = [...record.rpcCalcPctVOIntShareFedaralList];
    if (table === 'intfedfmly')
      grid = [...record.rpcParamVoIntShareFedaralFamiliList];
    const data = tableFldBlurAction(prop, table, val, indx, grid, blur, errmg);
    if (table === 'intcalc')
      tabdata.rpcParamVoIntShareIntCalList = data.newdata;
    if (table === 'intfed')
      tabdata.rpcCalcPctVOIntShareFedaralList = data.newdata;
    if (table === 'intfedfmly')
      tabdata.rpcParamVoIntShareFedaralFamiliList = data.newdata;
    if (blur) dispatch(errorMsg(data.err));
    dispatch({ type: actionType.INT_GRID_DATA, payload: tabdata });
    makeItDirty();
  };

  const unitTypeChangehandler = (val, prop, data, record, blur, err = []) => {
    let error;
    let list = [...err];
    const indx = data.node.rowIndex;
    if (val === '' || !val)
      error =
        prop === 'testAmt'
          ? `${Constants.THRESHOLD_UNIT_ERR} ${indx + 1}`
          : `${Constants.MAIL_ORDER_ERR} ${indx + 1}`;
    if (!/^(([0-9]*)|(([0-9]*)\.([0-9]*)))$/.test(val))
      error =
        prop === 'testAmt'
          ? `${Constants.THRESHOLD_UNIT_NUM_ERR} in Row ${indx + 1}`
          : `${Constants.MAIL_ORDER_NUM_ERR} in Row ${indx + 1}`;
    const newdata = record?.map((obj, ind) => {
      if (indx === ind) {
        if (blur) {
          if (error) {
            obj[`${prop}Err`] = true;
            obj[`${prop}Msg`] = error;
            list = [...new Set([...err, error])];
          } else {
            list = removeErr(err, [obj[`${prop}Msg`]]);
            obj[`${prop}Err`] = false;
            obj[`${prop}Msg`] = '';
          }
        }
        if (prop === 'testOnInd' && !val) {
          const er = removeErr(err, [
            data.data.testAmtMsg,
            data.data.mailOrderMultiplierMsg,
          ]);
          dispatch(errorMsg(er));
          obj.testAmtErr = false;
          obj.mailOrderMultiplierErr = false;
        }
        obj[prop] = val;
      }
      return obj;
    });
    dispatch({ type: actionType.UNIT_TYPE_AUDIT_GRID_DATA, payload: newdata });
    if (blur) dispatch(errorMsg(list));
    makeItDirty();
  };

  const groupChangehandler = (val, prop, indx, table, record, blur, errmg) => {
    const tabdata = { ...record };
    let grid;
    if (table === 'cmsrpt') grid = [...record.cmsReporting];
    if (table === 'cmsutil') grid = [...record.cmsUtilization];
    const data = tableFldBlurAction(prop, table, val, indx, grid, blur, errmg);
    if (table === 'cmsrpt') tabdata.cmsReporting = data.newdata;
    if (table === 'cmsutil') tabdata.cmsUtilization = data.newdata;
    if (blur) dispatch(errorMsg(data.err));
    dispatch({ type: actionType.GROUP_GRID_DATA, payload: tabdata });
    makeItDirty();
  };

  const enrollChangehandler = (val, prop, indx, record, error) => {
    const tabdata = [...record];
    const newdata = tabdata?.map((obj, ind) => {
      if (indx === ind) {
        const msg = `${Constants.ENROLL_TIMING_ERR} ${ind + 1}`;
        obj[prop] = val;
        if (prop === 'enrollmentTimingCd') {
          let err = [...error];
          if (!val || val === '-1') {
            obj.timingcdErr = true;
            obj.timingcdMsg = msg;
            err = [...error, msg];
          } else {
            err = removeErr(err, [msg]);
            obj.timingcdErr = false;
            obj.timingcdMsg = '';
          }
          dispatch(errorMsg(err));
        }
      }
      return obj;
    });
    dispatch({ type: actionType.ENROLL_GRID_DATA, payload: newdata });
    makeItDirty();
  };

  const frameworkComponents = {
    TextBoxRenderer: (cellInfo) => {
      const ura_grid_data = useSelector(
        (state) => state?.sharedState?.MaintainRebateReducer?.ura_grid_data
      );
      const err_msg = useSelector(
        (state) => state?.sharedState?.MaintainRebateReducer?.err_msg
      );
      return (
        <TextField
          id="startQtr01"
          className={
            cellInfo.data?.startQtrErr ? 'td-active-cell tBill-validate' : ''
          }
          InputProps={{ id: 'startQtr01' }}
          InputLabelProps={{ shrink: true }}
          value={cellInfo.data.startQtr || ''}
          disabled={!isEnablebyRole}
          onChange={(e) => {
            const data = qtrHandler(
              e.target.value,
              cellInfo,
              false,
              ura_grid_data,
              err_msg,
              'src',
              'startQtr'
            );
            dispatch({ type: actionType.URA_GRID_DATA, payload: data.tabdata });
            makeItDirty();
            cellInfo.api.refreshCells();
          }}
          onBlur={(e) => {
            const data = qtrHandler(
              e.target.value,
              cellInfo,
              true,
              ura_grid_data,
              err_msg,
              'src',
              'startQtr'
            );
            dispatch({ type: actionType.URA_GRID_DATA, payload: data.tabdata });
            dispatch(errorMsg([...new Set([...data.err])]));
            cellInfo.api.refreshCells();
          }}
          inputProps={{ maxLength:6 }}
          onKeyDown={(e) => {
            if (e.key === 'Tab' && !e.shiftKey) {
              let data = { ...ura_grid_data };
              let tableData = [...data.rpcUraSource];
              data.rpcUraSource = tableData.map((obj, ind) => {
                if (obj.id === cellInfo.data.id) obj.dropdownFocus = true;
                return obj;
              });
              dispatch({ type: actionType.URA_GRID_DATA, payload: data });
            }
          }}
        />
      );
    },
    DropdownRenderer: (cellInfo) => {
      const ura_source = useSelector(
        (state) => state?.sharedState?.RebatePgmReducer?.ura_source
      );
      const grid = useSelector(
        (state) => state?.sharedState?.MaintainRebateReducer?.ura_grid_data
      );
      const err = useSelector(
        (state) => state?.sharedState?.MaintainRebateReducer?.err_msg
      );
      const [dropDownFocus, setDropDownFocus] = React.useState(false);
      return (
        <TextField
          style={{ width: '150px' }}
          InputLabelProps={{ shrink: true }}
          value={cellInfo.data.rpcParamValue || ''}
          select
          autoFocus={cellInfo.data.dropdownFocus || dropDownFocus}
          disabled={!isEnablebyRole}
          onChange={(e) => {
            const ind = cellInfo.node.rowIndex;
            const { value } = e.target;
            uraChangehandler(
              value,
              'rpcParamValue',
              ind,
              'src',
              grid,
              null,
              err
            );
            cellInfo.api.refreshCells();
          }}
          onKeyDown={(e) => {
            if (e.key === 'Tab' && !e.shiftKey) {
              let data = { ...ura_grid_data };
              let tableData = [...data.rpcUraSource];
              data.rpcUraSource = tableData.map((obj) => {
                if (obj.id === cellInfo.data.id) obj.dropdownFocus = false;
                return obj;
              });
              setDropDownFocus(false);
              dispatch({ type: actionType.URA_GRID_DATA, payload: data });
              // setTimeout(() => uraRecordAdd('src', grid, err), 200);
            }
            if (e.key === 'Enter') setDropDownFocus(true);
          }}
        >
          <MenuItem key="" value="-1" className="frr-dropdown-blank-item" />
          {ura_source &&
            ura_source.map((item, ind) => (
              <MenuItem key={ind} value={item.codeValueID.codeValue}>
                {item.codeValueID.codeValue}: {item.shortDescription}
              </MenuItem>
            ))}
        </TextField>
      );
    },
    CheckboxRenderer: (cellInfo) => {
      const grid = useSelector(
        (state) => state?.sharedState?.MaintainRebateReducer?.ura_grid_data
      );
      const err = useSelector(
        (state) => state?.sharedState?.MaintainRebateReducer?.err_msg
      );
      return (
        // <div className="tbl-checkbox">
        //   <FormControlLabel
        //     control={<Checkbox color="primary" />}
        //     value={cellInfo.data.delete || false}
        //     onChange={(e, val) => {
        //       let ind = cellInfo.node.rowIndex;
        //       uraChangehandler(val, 'delete', ind, 'src', ura_grid_data);
        //       cellInfo.api.refreshCells();
        //     }}
        //     checked={cellInfo.data.delete || false}
        //   />
        // </div>
        <>
          <OverlayTrigger
            placement="bottom"
            overlay={<Tooltip id="add-tooltip">Add</Tooltip>}
          >
            <Button
              className="frr-box-shadow-none"
              data-testid=""
              aria-label="Add Update URA from Payments"
              variant="text"
              onClick={() => uraRecordAdd('src', grid, err)}
              disabled={!isEnablebyRole}
            >
              <SVGComponent iconName="Icon-addCircle" />{' '}
            </Button>
          </OverlayTrigger>
          <OverlayTrigger
            placement="bottom"
            overlay={<Tooltip>Delete</Tooltip>}
          >
            <Button
              className="th-ic trash-blue frr-box-shadow-none"
              variant="text"
              aria-label="Trash"
              data-test="deletePopup"
              onClick={() => {
                setDeleteModal(true);
                setDeleteInd({ table: 'src', grid: grid, data: cellInfo });
              }}
              disabled={!isEnablebyRole}
            >
              <SVGComponent iconName="Icon-delete" />
            </Button>
          </OverlayTrigger>
        </>
      );
    },
  };

  const uraCalcFrameworkComponents = {
    TextBoxRenderer: (cellInfo) => {
      const grid = useSelector(
        (state) => state?.sharedState?.MaintainRebateReducer?.ura_grid_data
      );
      const err_msg = useSelector(
        (state) => state?.sharedState?.MaintainRebateReducer?.err_msg
      );
      const last_ura_src_calc_qtr = useSelector(
        (state) =>
          state?.sharedState?.MaintainRebateReducer?.last_ura_src_calc_qtr
      );
      const onChange = (e, cellInfo, blur, key) => {
        const ind = cellInfo.node.rowIndex;
        let value;

        if (key === 'calcFixedPct' || key === 'calcGenericPct') {
          if (e.target.value && e.target.value.includes('.')) {
            if (AppConstants.BAL_PERCENT_REGEX.test(e.target.value)) {
              value = e.target.value;
            } else {
              return false;
            }
          } else if (AppConstants.RX_WITHOUT.test(e.target.value)) {
            value = e.target.value;
          } else {
            return false;
          }
        } else {
          value = e.target.value;
        }

        uraChangehandler(value, key, ind, 'calc', grid, blur, err_msg);
      };
      return (
        <>
          {cellInfo.column.colId === 'effectiveQtr' && (
            <TextField
              className={
                cellInfo.data?.effectiveQtrErr
                  ? 'td-active-cell tBill-validate'
                  : ''
              }
              inputProps={{ maxLength:6 }}
              InputLabelProps={{ shrink: true }}
              value={cellInfo.data.effectiveQtr}
              onChange={(e) => {
                const data = qtrHandler(
                  e.target.value,
                  cellInfo,
                  false,
                  grid,
                  err_msg,
                  'calc',
                  'effectiveQtr'
                );
                dispatch({
                  type: actionType.URA_GRID_DATA,
                  payload: data.tabdata,
                });
                makeItDirty();
                cellInfo.api.refreshCells();
              }}
              onBlur={(e) => {
                const { tabdata, err } = qtrHandler(
                  e.target.value,
                  cellInfo,
                  true,
                  grid,
                  err_msg,
                  'calc',
                  'effectiveQtr',
                  true,
                  last_frozen_qtr,
                  last_ura_src_calc_qtr,
                  active_tab
                );
                dispatch({
                  type: actionType.URA_GRID_DATA,
                  payload: tabdata,
                });
                dispatch(errorMsg([...new Set([...err])]));
                cellInfo.api.refreshCells();
              }}
            />
          )}
          {cellInfo.column.colId === 'calcFixedPct' && (
            <TextField
              InputLabelProps={{ shrink: true }}
              inputProps={{ maxLength: 16 }}
              className={
                cellInfo.data?.calcFixedPctErr
                  ? 'td-active-cell tBill-validate'
                  : ''
              }
              value={cellInfo.data.calcFixedPct}
              onChange={(e) => onChange(e, cellInfo, false, 'calcFixedPct')}
              onBlur={(e) => onChange(e, cellInfo, true, 'calcFixedPct')}
              disabled={
                cellInfo.data.calcMethodCd === 'CMSPRI' ||
                cellInfo.data.calcMethodCd === 'CONTRACT'
              }
            />
          )}
          {cellInfo.column.colId === 'calcGenericPct' && (
            <TextField
              InputLabelProps={{ shrink: true }}
              inputProps={{ maxLength: 16 }}
              value={cellInfo.data.calcGenericPct}
              className={
                cellInfo.data?.calcGenericPctErr
                  ? 'td-active-cell tBill-validate'
                  : ''
              }
              onChange={(e) => onChange(e, cellInfo, false, 'calcGenericPct')}
              onBlur={(e) => onChange(e, cellInfo, true, 'calcGenericPct')}
              disabled={
                cellInfo.data.calcMethodCd === 'CMSPRI' ||
                cellInfo.data.calcMethodCd === 'CONTRACT' ||
                cellInfo.data.calcMethodCd === 'AMP' ||
                cellInfo.data.calcMethodCd === 'CMSAWP'
              }
              onKeyDown={(e) => {
                // if (
                //   (e.key === 'Tab' && !e.shiftKey) ||
                //   e.key === 'ArrowRight'
                // ) {
                //   uraRecordAdd('calc', grid, err_msg);
                // }
              }}
            />
          )}
        </>
      );
    },
    DropdownRenderer: (cellInfo) => {
      const ura_calc = useSelector(
        (state) => state?.sharedState?.RebatePgmReducer?.ura_calc
      );
      const grid = useSelector(
        (state) => state?.sharedState?.MaintainRebateReducer?.ura_grid_data
      );
      const err = useSelector(
        (state) => state?.sharedState?.MaintainRebateReducer?.err_msg
      );
      return (
        <TextField
          style={{ width: '150px' }}
          InputLabelProps={{ shrink: true }}
          value={cellInfo.data.calcMethodCd || ''}
          select
          className={
            cellInfo.data?.calcMethodCdErr
              ? 'td-active-cell tBill-validate'
              : ''
          }
          onChange={(e) => {
            const val = e.target.value;
            const ind = cellInfo.node.rowIndex;
            uraChangehandler(val, 'calcMethodCd', ind, 'calc', grid, true, err);
            if (
              cellInfo.data.calcMethodCd === 'CMSPRI' ||
              cellInfo.data.calcMethodCd === 'CONTRACT'
            ) {
              const ind = cellInfo.node.rowIndex;
              uraChangehandler(
                '',
                'calcFixedPct',
                ind,
                'calc',
                grid,
                false,
                err
              );
            }

            if (
              cellInfo.data.calcMethodCd === 'CMSPRI' ||
              cellInfo.data.calcMethodCd === 'CONTRACT' ||
              cellInfo.data.calcMethodCd === 'AMP' ||
              cellInfo.data.calcMethodCd === 'CMSAWP'
            ) {
              const ind = cellInfo.node.rowIndex;
              uraChangehandler(
                '',
                'calcGenericPct',
                ind,
                'calc',
                grid,
                false,
                err
              );
            }
          }}
        >
          <MenuItem className="frr-dropdown-blank-item" key="" value="-1" />
          {ura_calc &&
            ura_calc.map((item, ind) => (
              <MenuItem key={ind} value={item.codeValueID.codeValue}>
                {item.codeValueID.codeValue}: {item.shortDescription}
              </MenuItem>
            ))}
        </TextField>
      );
    },
    CheckboxRenderer: (cellInfo) => {
      const grid = useSelector(
        (state) => state?.sharedState?.MaintainRebateReducer?.ura_grid_data
      );
      const err = useSelector(
        (state) => state?.sharedState?.MaintainRebateReducer?.err_msg
      );
      return (
        // <div className="tbl-checkbox">
        //   <FormControlLabel
        //     control={<Checkbox color="primary" />}
        //     value={cellInfo.data.delete || false}
        //     onChange={(e, val) => {
        //       let ind = cellInfo.node.rowIndex;
        //       uraChangehandler(val, 'delete', ind, 'calc', grid);
        //       cellInfo.api.refreshCells();
        //     }}
        //     checked={cellInfo.data.delete || false}
        //   />
        // </div>
        <>
          <OverlayTrigger
            placement="bottom"
            overlay={<Tooltip id="add-tooltip">Add</Tooltip>}
          >
            <Button
              className="frr-box-shadow-none"
              data-testid=""
              aria-label="Add URA Calculation"
              variant="text"
              disabled={
                !grid.rpcUraSource.some((o) => o.rpcParamValue === 'CALC')
              }
              onClick={() => uraRecordAdd('calc', grid, err)}
            >
              <SVGComponent iconName="Icon-addCircle" />{' '}
            </Button>
          </OverlayTrigger>
          <OverlayTrigger
            placement="bottom"
            overlay={<Tooltip>Delete</Tooltip>}
          >
            <Button
              className="th-ic trash-blue frr-box-shadow-none"
              variant="text"
              aria-label="Trash"
              data-test="deletePopup"
              onClick={() => {
                setDeleteModal(true);
                setDeleteInd({ table: 'calc', grid: grid, data: cellInfo });
              }}
              disabled={
                !grid.rpcUraSource.some((o) => o.rpcParamValue === 'CALC')
              }
            >
              <SVGComponent iconName="Icon-delete" />
            </Button>
          </OverlayTrigger>
        </>
      );
    },
  };

  const payFrameworkComponent = {
    TextBoxRenderer: (cellInfo) => {
      const ura_grid_data = useSelector(
        (state) => state?.sharedState?.MaintainRebateReducer?.ura_grid_data
      );
      const err_msg = useSelector(
        (state) => state?.sharedState?.MaintainRebateReducer?.err_msg
      );
      return (
        <TextField
          className={
            cellInfo.data?.startQtrErr ? 'td-active-cell tBill-validate' : ''
          }
          inputProps={{ maxLength:6 }}
          InputLabelProps={{ shrink: true }}
          value={cellInfo.data.startQtr || ''}
          disabled={pgm_detail?.planTypeCd === 'FD'}
          onChange={(e) => {
            const data = qtrHandler(
              e.target.value,
              cellInfo,
              false,
              ura_grid_data,
              err_msg,
              'pay',
              'startQtr'
            );
            dispatch({ type: actionType.URA_GRID_DATA, payload: data.tabdata });
            makeItDirty();
            cellInfo.api.refreshCells();
          }}
          onBlur={(e) => {
            const data = qtrHandler(
              e.target.value,
              cellInfo,
              true,
              ura_grid_data,
              err_msg,
              'pay',
              'startQtr'
            );
            dispatch({ type: actionType.URA_GRID_DATA, payload: data.tabdata });
            dispatch(errorMsg([...new Set([...data.err])]));
            cellInfo.api.refreshCells();
          }}
        />
      );
    },
    CheckboxRenderer: (cellInfo) => {
      const grid = useSelector(
        (state) => state?.sharedState?.MaintainRebateReducer?.ura_grid_data
      );
      const err = useSelector(
        (state) => state?.sharedState?.MaintainRebateReducer?.err_msg
      );
      return (
        <>
          {cellInfo.column.colId === 'rpcParamValue' && (
            <div className="tbl-checkbox">
              <FormControlLabel
                control={<Checkbox color="primary" />}
                value={cellInfo.data.rpcParamValue == 0 ? false : true || false}
                disabled={pgm_detail?.planTypeCd === 'FD'}
                onChange={(e, val) => {
                  const ind = cellInfo.node.rowIndex;
                  const data = val === true ? 1 : 0;
                  uraChangehandler(data, 'rpcParamValue', ind, 'pay', grid);
                  cellInfo.api.refreshCells();
                }}
                checked={
                  cellInfo.data.rpcParamValue == 0 ? false : true || false
                }
                onKeyDown={(e) => {
                  //   if (
                  //     (e.key === 'Tab' && !e.shiftKey) ||
                  //     e.key === 'ArrowRight'
                  //   ) {
                  //     uraRecordAdd('pay', grid, err);
                  //   }
                }}
              />
            </div>
          )}
          {cellInfo.column.colId === 'delete' && (
            // <div className="tbl-checkbox">
            //   <FormControlLabel
            //     control={<Checkbox color="primary" />}
            //     value={cellInfo.data.delete || false}
            //     onChange={(e, val) => {
            //       let ind = cellInfo.node.rowIndex;
            //       uraChangehandler(val, 'delete', ind, 'pay', grid);
            //       cellInfo.api.refreshCells();
            //     }}
            //     checked={cellInfo.data.delete || false}
            //   />
            // </div>
            <>
              <OverlayTrigger
                placement="bottom"
                overlay={<Tooltip id="add-tooltip">Add</Tooltip>}
              >
                <Button
                  className="frr-box-shadow-none"
                  data-testid=""
                  aria-label="Add Update URA from Payments"
                  variant="text"
                  onClick={() => uraRecordAdd('pay', grid, err)}
                  disabled={pgm_detail?.planTypeCd === 'FD'}
                >
                  <SVGComponent iconName="Icon-addCircle" />{' '}
                </Button>
              </OverlayTrigger>
              <OverlayTrigger
                placement="bottom"
                overlay={<Tooltip>Delete</Tooltip>}
              >
                <Button
                  className="th-ic trash-blue frr-box-shadow-none"
                  variant="text"
                  aria-label="Trash"
                  onClick={() => {
                    setDeleteModal(true);
                    setDeleteInd({ table: 'pay', grid: grid, data: cellInfo });
                  }}
                  disabled={pgm_detail?.planTypeCd === 'FD'}
                >
                  <SVGComponent iconName="Icon-delete" />
                </Button>
              </OverlayTrigger>
            </>
          )}
        </>
      );
    },
  };

  const intCalcFrameworkComponents = {
    TextBoxRenderer: (cellInfo) => {
      const grid = useSelector(
        (state) => state?.sharedState?.MaintainRebateReducer?.int_grid_data
      );
      const err_msg = useSelector(
        (state) => state?.sharedState?.MaintainRebateReducer?.err_msg
      );

      const pgmDetails = useSelector(
        (state) => state?.sharedState?.MaintainRebateReducer?.pgm_detail
      );
      // (!pgmDetails?.planTypeCd || pgmDetails?.planTypeCd === 'FD') && cellInfo.rowIndex === 0
      const isDisabled = !!(
        !pgmDetails?.planTypeCd || pgmDetails?.planTypeCd === 'FD'
      );

      const onChange = (e, cellInfo, blur) => {
        intChangehandler(
          e.target.value,
          'calcFixedPct',
          cellInfo.node.rowIndex,
          'intcalc',
          grid,
          blur,
          err_msg
        );
      };

      return (
        <>
          {cellInfo.column.colId === 'effectiveQtr' && (
            <TextField
              className={
                cellInfo.data?.effectiveQtrErr
                  ? 'td-active-cell tBill-validate'
                  : ''
              }
              InputLabelProps={{ shrink: true }}
              value={cellInfo.data.effectiveQtr || ''}
              disabled={isDisabled || !isEnablebyRole}
              onChange={(e) => {
                const data = qtrHandler(
                  e.target.value,
                  cellInfo,
                  false,
                  grid,
                  err_msg,
                  'intcalc',
                  'effectiveQtr'
                );
                dispatch({
                  type: actionType.INT_GRID_DATA,
                  payload: data.tabdata,
                });
                makeItDirty();
                cellInfo.api.refreshCells();
              }}
              inputProps={{ maxLength:6 }}
              onBlur={(e) => {
                const data = qtrHandler(
                  e.target.value,
                  cellInfo,
                  true,
                  grid,
                  err_msg,
                  'intcalc',
                  'effectiveQtr'
                );
                dispatch({
                  type: actionType.INT_GRID_DATA,
                  payload: data.tabdata,
                });
                dispatch(errorMsg([...new Set([...data.err])]));
                cellInfo.api.refreshCells();
              }}
            />
          )}
          {cellInfo.column.colId === 'calcFixedPct' && (
            <TextField
              InputLabelProps={{ shrink: true }}
              value={cellInfo.data.calcFixedPct}
              className={
                cellInfo.data?.calcFixedPctErr
                  ? 'td-active-cell tBill-validate'
                  : ''
              }
              onChange={(e) => onChange(e, cellInfo, false)}
              onBlur={(e) => onChange(e, cellInfo, true)}
              disabled={
                isDisabled ||
                cellInfo.data.calcMethodCd === 'T' ||
                !isEnablebyRole
              }
              onKeyDown={(e) => {
                // if (
                //   (e.key === 'Tab' && !e.shiftKey) ||
                //   e.key === 'ArrowRight'
                // ) {
                //   intRecordAdd('intcalc', grid, err_msg);
                // }
              }}
            />
          )}
        </>
      );
    },
    DropdownRenderer: (cellInfo) => {
      const int_calc = useSelector(
        (state) => state?.sharedState?.RebatePgmReducer?.int_calc
      );
      const grid = useSelector(
        (state) => state?.sharedState?.MaintainRebateReducer?.int_grid_data
      );
      const err = useSelector(
        (state) => state?.sharedState?.MaintainRebateReducer?.err_msg
      );
      const pgmDetails = useSelector(
        (state) => state?.sharedState?.MaintainRebateReducer?.pgm_detail
      );
      // (!pgmDetails?.planTypeCd || pgmDetails?.planTypeCd === 'FD') && cellInfo.rowIndex === 0
      const isDisabled = !!(
        !pgmDetails?.planTypeCd || pgmDetails?.planTypeCd === 'FD'
      );
      return (
        <TextField
          style={{ width: '150px' }}
          InputLabelProps={{ shrink: true }}
          value={cellInfo.data.calcMethodCd || ''}
          select
          className={
            cellInfo.data?.calcMethodCdErr
              ? 'td-active-cell tBill-validate'
              : ''
          }
          onChange={(e) => {
            const i = cellInfo.node.rowIndex;
            const v = e.target.value;
            intChangehandler(v, 'calcMethodCd', i, 'intcalc', grid, true, err);

            if (v === 'T') {
              intChangehandler(
                '',
                'calcFixedPct',
                i,
                'intcalc',
                grid,
                false,
                err
              );
            }
          }}
          disabled={isDisabled || !isEnablebyRole}
        >
          <MenuItem className="frr-dropdown-blank-item" key="" value="-1" />
          {int_calc &&
            int_calc.map((item, ind) => (
              <MenuItem key={ind} value={item.codeValueID.codeValue}>
                {item.codeValueID.codeValue}: {item.shortDescription}
              </MenuItem>
            ))}
        </TextField>
      );
    },
    CheckboxRenderer: (cellInfo) => {
      const grid = useSelector(
        (state) => state?.sharedState?.MaintainRebateReducer?.int_grid_data
      );
      const err = useSelector(
        (state) => state?.sharedState?.MaintainRebateReducer?.err_msg
      );

      const pgmDetails = useSelector(
        (state) => state?.sharedState?.MaintainRebateReducer?.pgm_detail
      );
      // (!pgmDetails?.planTypeCd || pgmDetails?.planTypeCd === 'FD') && cellInfo.rowIndex === 0
      const isDisabled = !!(
        !pgmDetails?.planTypeCd || pgmDetails?.planTypeCd === 'FD'
      );
      return (
        // <div className="tbl-checkbox">
        //   <FormControlLabel
        //     control={<Checkbox color="primary" />}
        //     value={cellInfo.data.delete}
        //     onChange={(e, val) => {
        //       let ind = cellInfo.node.rowIndex;
        //       intChangehandler(val, 'delete', ind, 'intcalc', grid);
        //     }}
        //     checked={cellInfo.data.delete}
        //     disabled={pgm_detail?.planTypeCd === 'FD'}
        //   />
        // </div>
        <>
          <OverlayTrigger
            placement="bottom"
            overlay={<Tooltip id="add-tooltip">Add</Tooltip>}
          >
            <Button
              className="frr-box-shadow-none"
              data-testid=""
              aria-label="Add Interest Calculation"
              variant="text"
              disabled={isDisabled}
              onClick={() => intRecordAdd('intcalc', grid, err)}
            >
              <SVGComponent iconName="Icon-addCircle" />{' '}
            </Button>
          </OverlayTrigger>
          <OverlayTrigger
            placement="bottom"
            overlay={<Tooltip>Delete</Tooltip>}
          >
            <Button
              className="th-ic trash-blue frr-box-shadow-none"
              variant="text"
              aria-label="Trash"
              data-test="deletePopup"
              disabled={isDisabled}
              onClick={() => {
                setDeleteModal(true);
                setDeleteInd({ table: 'intcalc', grid: grid, data: cellInfo });
              }}
            >
              <SVGComponent iconName="Icon-delete" />
            </Button>
          </OverlayTrigger>
        </>
      );
    },
  };

  const intFedaralFrameworkComponents = {
    TextBoxRenderer: (cellInfo) => {
      const grid = useSelector(
        (state) => state?.sharedState?.MaintainRebateReducer?.int_grid_data
      );
      const err_msg = useSelector(
        (state) => state?.sharedState?.MaintainRebateReducer?.err_msg
      );
      const onChange = (e, cellInfo, blur) => {
        let value = e.target.value;
        if (value && value.includes('.')) {
          if (AppConstants.AMOUNT.test(value)) {
            value = e.target.value;
          } else {
            return false;
          }
        } else if (AppConstants.RX_WITHOUT.test(value)) {
          value = e.target.value;
        } else {
          return false;
        }
        if (blur) value = value ? parseFloat(value).toFixed(2) : '';
        intChangehandler(
          value,
          'rpcParamValue',
          cellInfo.node.rowIndex,
          'intfed',
          grid,
          blur,
          err_msg
        );
      };
      return (
        <>
          {cellInfo.column.colId === 'startQtr' && (
            <TextField
              disabled={!isEnablebyRole}
              className={
                cellInfo.data?.startQtrErr
                  ? 'td-active-cell tBill-validate'
                  : ''
              }
              InputLabelProps={{ shrink: true }}
              value={cellInfo.data.startQtr || ''}
              onChange={(e) => {
                const data = qtrHandler(
                  e.target.value,
                  cellInfo,
                  false,
                  grid,
                  err_msg,
                  'intfed',
                  'startQtr'
                );
                dispatch({
                  type: actionType.INT_GRID_DATA,
                  payload: data.tabdata,
                });
                makeItDirty();
                cellInfo.api.refreshCells();
              }}
              inputProps={{ maxLength:6 }}
              onBlur={(e) => {
                const data = qtrHandler(
                  e.target.value,
                  cellInfo,
                  true,
                  grid,
                  err_msg,
                  'intfed',
                  'startQtr'
                );
                dispatch({
                  type: actionType.INT_GRID_DATA,
                  payload: data.tabdata,
                });
                dispatch(errorMsg([...new Set([...data.err])]));
                cellInfo.api.refreshCells();
              }}
            />
          )}
          {cellInfo.column.colId === 'rpcParamValue' && (
            <TextField
              disabled={!isEnablebyRole}
              className={
                cellInfo.data?.rpcParamValueErr
                  ? 'td-active-cell tBill-validate'
                  : ''
              }
              InputLabelProps={{ shrink: true }}
              value={cellInfo.data.rpcParamValue}
              onChange={(e) => onChange(e, cellInfo, false)}
              onBlur={(e) => onChange(e, cellInfo, true)}
              onKeyDown={(e) => {
                // if (
                //   (e.key === 'Tab' && !e.shiftKey) ||
                //   e.key === 'ArrowRight'
                // ) {
                //   intRecordAdd('intfed', grid, err_msg);
                // }
              }}
            />
          )}
        </>
      );
    },
    CheckboxRenderer: (cellInfo) => {
      const grid = useSelector(
        (state) => state?.sharedState?.MaintainRebateReducer?.int_grid_data
      );
      const err = useSelector(
        (state) => state?.sharedState?.MaintainRebateReducer?.err_msg
      );
      return (
        // <div className="tbl-checkbox">
        //   <FormControlLabel
        //     control={<Checkbox color="primary" />}
        //     value={cellInfo.data.delete}
        //     onChange={(e, val) => {
        //       let ind = cellInfo.node.rowIndex;
        //       intChangehandler(val, 'delete', ind, 'intfed', grid);
        //     }}
        //     checked={cellInfo.data.delete}
        //   />
        // </div>
        <>
          <OverlayTrigger
            placement="bottom"
            overlay={<Tooltip id="add-tooltip">Add</Tooltip>}
          >
            <Button
              className="frr-box-shadow-none"
              data-testid=""
              aria-label="Add Federal %"
              disabled={!isEnablebyRole}
              variant="text"
              onClick={() => intRecordAdd('intfed', grid, err)}
            >
              <SVGComponent iconName="Icon-addCircle" />{' '}
            </Button>
          </OverlayTrigger>
          <OverlayTrigger
            placement="bottom"
            overlay={<Tooltip>Delete</Tooltip>}
          >
            <Button
              className="th-ic trash-blue frr-box-shadow-none"
              variant="text"
              aria-label="Trash"
              disabled={!isEnablebyRole}
              onClick={() => {
                setDeleteModal(true);
                setDeleteInd({ table: 'intfed', grid: grid, data: cellInfo });
              }}
            >
              <SVGComponent iconName="Icon-delete" />
            </Button>
          </OverlayTrigger>
        </>
      );
    },
  };

  const intFedFamilyFrameworkComponents = {
    TextBoxRenderer: (cellInfo) => {
      const grid = useSelector(
        (state) => state?.sharedState?.MaintainRebateReducer?.int_grid_data
      );
      const err_msg = useSelector(
        (state) => state?.sharedState?.MaintainRebateReducer?.err_msg
      );
      const onChange = (e, cellInfo, blur) => {
        let value = e.target.value;
        if (value && value.includes('.')) {
          if (AppConstants.AMOUNT.test(value)) value = e.target.value;
          else return false;
        } else if (AppConstants.RX_WITHOUT.test(value)) {
          value = e.target.value;
        } else {
          return false;
        }
        if (blur) value = value ? parseFloat(value).toFixed(2) : '';
        intChangehandler(
          value,
          'rpcParamValue',
          cellInfo.node.rowIndex,
          'intfedfmly',
          grid,
          blur,
          err_msg
        );
      };
      return (
        <>
          {cellInfo.column.colId === 'startQtr' && (
            <TextField
              disabled={!isEnablebyRole}
              className={
                cellInfo.data?.startQtrErr
                  ? 'td-active-cell tBill-validate'
                  : ''
              }
              InputLabelProps={{ shrink: true }}
              value={cellInfo.data.startQtr || ''}
              onChange={(e) => {
                const data = qtrHandler(
                  e.target.value,
                  cellInfo,
                  false,
                  grid,
                  err_msg,
                  'intfedfmly',
                  'startQtr'
                );
                dispatch({
                  type: actionType.INT_GRID_DATA,
                  payload: data.tabdata,
                });
                makeItDirty();
                cellInfo.api.refreshCells();
              }}
              inputProps={{ maxLength:6 }}
              onBlur={(e) => {
                const data = qtrHandler(
                  e.target.value,
                  cellInfo,
                  true,
                  grid,
                  err_msg,
                  'intfedfmly',
                  'startQtr'
                );
                dispatch({
                  type: actionType.INT_GRID_DATA,
                  payload: data.tabdata,
                });
                dispatch(errorMsg([...new Set([...data.err])]));
                cellInfo.api.refreshCells();
              }}
            />
          )}
          {cellInfo.column.colId === 'rpcParamValue' && (
            <TextField
              disabled={!isEnablebyRole}
              className={
                cellInfo.data?.rpcParamValueErr
                  ? 'td-active-cell tBill-validate'
                  : ''
              }
              InputLabelProps={{ shrink: true }}
              value={cellInfo.data.rpcParamValue}
              onChange={(e) => onChange(e, cellInfo, false)}
              onBlur={(e) => onChange(e, cellInfo, true)}
              onKeyDown={(e) => {
                // if (
                //   (e.key === 'Tab' && !e.shiftKey) ||
                //   e.key === 'ArrowRight'
                // ) {
                //   intRecordAdd('intfedfmly', grid, err_msg);
                // }
              }}
            />
          )}
        </>
      );
    },
    CheckboxRenderer: (cellInfo) => {
      const grid = useSelector(
        (state) => state?.sharedState?.MaintainRebateReducer?.int_grid_data
      );
      const err = useSelector(
        (state) => state?.sharedState?.MaintainRebateReducer?.err_msg
      );
      return (
        // <div className="tbl-checkbox">
        //   <FormControlLabel
        //     control={<Checkbox color="primary" />}
        //     value={cellInfo.data.delete}
        //     onChange={(e, val) => {
        //       let ind = cellInfo.node.rowIndex;
        //       intChangehandler(val, 'delete', ind, 'intfedfmly', grid);
        //     }}
        //     checked={cellInfo.data.delete}
        //   />
        // </div>
        <>
          <OverlayTrigger
            placement="bottom"
            overlay={<Tooltip id="add-tooltip">Add</Tooltip>}
          >
            <Button
              className="frr-box-shadow-none"
              data-testid=""
              aria-label="Add Federal Family Planning %"
              variant="text"
              disabled={!isEnablebyRole}
              onClick={() => intRecordAdd('intfedfmly', grid, err)}
            >
              <SVGComponent iconName="Icon-addCircle" />{' '}
            </Button>
          </OverlayTrigger>
          <OverlayTrigger
            placement="bottom"
            overlay={<Tooltip>Delete</Tooltip>}
          >
            <Button
              className="th-ic trash-blue frr-box-shadow-none"
              variant="text"
              aria-label="Trash"
              disabled={!isEnablebyRole}
              onClick={() => {
                setDeleteModal(true);
                setDeleteInd({
                  table: 'intfedfmly',
                  grid: grid,
                  data: cellInfo,
                });
              }}
            >
              <SVGComponent iconName="Icon-delete" />
            </Button>
          </OverlayTrigger>
        </>
      );
    },
  };

  const unitTypeFrameworkComponent = {
    TextBoxRenderer: (cellInfo) => {
      const grid = useSelector(
        (state) => state?.sharedState?.MaintainRebateReducer?.unit_type_data
      );
      const default_audit = useSelector(
        (state) => state?.sharedState?.MaintainRebateReducer?.default_audit
      );
      const err = useSelector(
        (state) => state?.sharedState?.MaintainRebateReducer?.err_msg
      );
      const onchange = (e, prop, data, blur) => {
        const val = e.target.value;
        unitTypeChangehandler(val, prop, data, grid, blur, err);
      };
      return (
        <>
          {cellInfo.column.colId === 'testAmt' && (
            <TextField
              InputProps={{
                id: 'testAmt03',
                inputComponent: NumberFormatCustom,
                inputProps: {
                  isAllowed: ({ floatValue }) =>
                    floatValue === undefined ||
                    /^\d{0,7}(\.\d{0,2})?$/.test(floatValue.toString()),
                },
              }}
              InputLabelProps={{ shrink: true }}
              className={
                cellInfo.data?.testAmtErr ? 'td-active-cell tBill-validate' : ''
              }
              inputProps={{ maxLength:6 }}
              value={cellInfo.data.testAmt}
              disabled={
                !cellInfo.data.testOnInd ||
                default_audit ||
                pgm_detail.planTypeCd === 'SUPP' ||
                !isEnablebyRole
              }
              onChange={(e) => {
                // let val = e.target.value;
                // unitTypeChangehandler(val, 'testAmt', cellInfo, grid);
                // makeItDirty();
                // cellInfo.api.refreshCells();
                onchange(e, 'testAmt', cellInfo, false);
              }}
              onBlur={(e) => {
                onchange(e, 'testAmt', cellInfo, true);
                // let i = cellInfo.node.rowIndex + 1;
                // let val = e.target.value;
                // if (val === '') {
                //   `${Constants.THRESHOLD_UNIT_ERR} ${i}`;
                // } else if (!/^(([0-9]*)|(([0-9]*)\.([0-9]*)))$/.test(val)) {
                //   setErrorMessage(Constants.THRESHOLD_UNIT_NUM_ERR);
                //   setErrorPopup(true);
                // } else {
                //   let error = removeErr(err, [
                //     `${Constants.THRESHOLD_UNIT_ERR} ${i}`,
                //     `${Constants.THRESHOLD_UNIT_NUM_ERR} in Row ${i}`,
                //   ]);
                //   dispatch(errorMsg(error));
                // }
              }}
            />
          )}
          {cellInfo.column.colId === 'mailOrderMultiplier' && (
            <TextField
              InputProps={{
                id: 'mailOrderMultiplier01',
                inputComponent: NumberFormatCustom,
                inputProps: {
                  isAllowed: ({ floatValue }) =>
                    floatValue === undefined ||
                    /^\d{0,5}(\.\d{0,6})?$/.test(floatValue.toString()),
                },
              }}
              InputLabelProps={{ shrink: true }}
              value={cellInfo.data.mailOrderMultiplier}
              className={
                cellInfo.data?.mailOrderMultiplierErr
                  ? 'td-active-cell tBill-validate'
                  : ''
              }
              disabled={
                !cellInfo.data.testOnInd ||
                default_audit ||
                pgm_detail.planTypeCd === 'SUPP' ||
                !isEnablebyRole
              }
              onChange={(e) => {
                // let l = e.target.value;
                // unitTypeChangehandler(l, 'mailOrderMultiplier', cellInfo, grid);
                // makeItDirty();
                onchange(e, 'mailOrderMultiplier', cellInfo, false);
              }}
              onBlur={(e) => {
                // if (!/^(([0-9]*)|(([0-9]*)\.([0-9]*)))$/.test(e.target.value)) {
                //   setErrorMessage(Constants.MAIL_ORDER_NUM_ERR);
                //   setErrorPopup(true);
                // } else {
                //   let i = cellInfo.node.rowIndex + 1;
                //   let error = removeErr(err, [
                //     `${Constants.MAIL_ORDER_ERR} ${i}`,
                //     `${Constants.MAIL_ORDER_NUM_ERR} in Row ${i}`,
                //   ]);
                //   dispatch(errorMsg(error));
                // }
                onchange(e, 'mailOrderMultiplier', cellInfo, true);
              }}
            />
          )}
        </>
      );
    },
    CheckboxRenderer: (cellInfo) => {
      const grid = useSelector(
        (state) => state?.sharedState?.MaintainRebateReducer?.unit_type_data
      );
      const default_audit = useSelector(
        (state) => state?.sharedState?.MaintainRebateReducer?.default_audit
      );
      const err = useSelector(
        (state) => state?.sharedState?.MaintainRebateReducer?.err_msg
      );
      return (
        <div className="tbl-checkbox">
          <FormControlLabel
            control={<Checkbox color="primary" />}
            disabled={
              default_audit ||
              pgm_detail.planTypeCd === 'SUPP' ||
              !isEnablebyRole
            }
            value={cellInfo.data.testOnInd === 1}
            onChange={(e, val) => {
              const value = val == true ? 1 : 0;
              unitTypeChangehandler(
                value,
                'testOnInd',
                cellInfo,
                grid,
                false,
                err
              );
            }}
            checked={cellInfo.data.testOnInd === 1}
          />
        </div>
      );
    },
  };

  const cmsReportFrameworkComponents = {
    TextBoxRenderer: (cellInfo) => {
      const grid = useSelector(
        (state) => state?.sharedState?.MaintainRebateReducer?.group_data
      );
      const err_msg = useSelector(
        (state) => state?.sharedState?.MaintainRebateReducer?.err_msg
      );
      const onchange = (e, data, blur) => {
        let obj;
        const val = e.target.value;
        const cid = data.column.colId;
        if (!blur)
          obj = qtrHandler(val, data, false, grid, err_msg, 'cmsrpt', cid);
        else
          obj = qtrHandler(
            val,
            data,
            true,
            grid,
            err_msg,
            'cmsrpt',
            cid,
            true,
            cms_freeze_qtr
          );
        dispatch({
          type: actionType.GROUP_GRID_DATA,
          payload: obj.tabdata,
        });
        if (!blur) makeItDirty();
        else dispatch(errorMsg([...new Set([...obj.err])]));
        data.api.refreshCells();
      };
      const fldChange = (e, cellInfo, fld, blur) => {
        const ind = cellInfo.node.rowIndex;
        const val = e.target.value;
        groupChangehandler(val, fld, ind, 'cmsrpt', grid, blur, err_msg);
      };
      const disableFld =
        !cellInfo.data.newFlag &&
        cellInfo.data.startQtr &&
        !cellInfo.data.startQtrErr &&
        cms_freeze_qtr &&
        !compareQtrs(cellInfo.data.startQtr, cms_freeze_qtr);
      return (
        <>
          {cellInfo.column.colId === 'startQtr' && (
            <TextField
              className={
                cellInfo.data?.startQtrErr
                  ? 'td-active-cell tBill-validate'
                  : ''
              }
              InputLabelProps={{ shrink: true, tabIndex: 0 }}
              inputProps={{ maxLength: 6 }}
              value={cellInfo.data.startQtr}
              onChange={(e) => onchange(e, cellInfo, false)}
              onBlur={(e) => onchange(e, cellInfo, true)}
              disabled={disableFld || !isEnablebyRole}
            />
          )}
          {cellInfo.column.colId === 'endQtr' && (
            <OverlayTrigger
              placement="bottom"
              overlay={
                <Tooltip style={disableFld ? {} : { opacity: 0 }}>
                  CMS reporting group record cannot be updated since the group
                  is used. Please use End quarter instead
                </Tooltip>
              }
            >
              <TextField
                className={
                  cellInfo.data?.endQtrErr
                    ? 'td-active-cell tBill-validate'
                    : ''
                }
                inputProps={{ maxLength: 6 }}
                InputLabelProps={{ shrink: true, tabIndex: 0 }}
                value={cellInfo.data.endQtr}
                onChange={(e) => onchange(e, cellInfo, false)}
                onBlur={(e) => onchange(e, cellInfo, true)}
                disabled={!isEnablebyRole}
              />
            </OverlayTrigger>
          )}
          {cellInfo.column.colId === 'cmsRptGroupNum' && (
            <TextField
              InputLabelProps={{ shrink: true }}
              value={cellInfo.data.cmsRptGroupNum}
              className={
                cellInfo.data?.cmsRptGroupNumErr
                  ? 'td-active-cell tBill-validate'
                  : ''
              }
              inputProps={{ maxLength: 2 }}
              onChange={(e) => fldChange(e, cellInfo, 'cmsRptGroupNum', false)}
              onBlur={(e) => fldChange(e, cellInfo, 'cmsRptGroupNum', true)}
              disabled={disableFld || !isEnablebyRole}
            />
          )}
          {cellInfo.column.colId === 'cmsRptGroupName' && (
            <TextField
              InputLabelProps={{ shrink: true }}
              inputProps={{ maxLength: 60 }}
              value={cellInfo.data.cmsRptGroupName}
              className={
                cellInfo.data?.cmsRptGroupNameErr
                  ? 'td-active-cell tBill-validate'
                  : ''
              }
              onChange={(e) => fldChange(e, cellInfo, 'cmsRptGroupName', false)}
              onBlur={(e) => fldChange(e, cellInfo, 'cmsRptGroupName', true)}
              disabled={disableFld || !isEnablebyRole}
            />
          )}
          {cellInfo.column.colId === 'cmsRptTitle' && (
            <TextField
              inputProps={{ maxLength: 60 }}
              InputLabelProps={{ shrink: true }}
              value={cellInfo.data.cmsRptTitle}
              className={
                cellInfo.data?.cmsRptTitleErr
                  ? 'td-active-cell tBill-validate'
                  : ''
              }
              onChange={(e) => fldChange(e, cellInfo, 'cmsRptTitle', false)}
              onBlur={(e) => fldChange(e, cellInfo, 'cmsRptTitle', true)}
              disabled={disableFld || !isEnablebyRole}
              onKeyDown={(e) => {
                if (
                  ((e.key === 'Tab' && !e.shiftKey) ||
                    e.key === 'ArrowRight') &&
                  grid.cmsReporting.length === cellInfo.rowIndex + 1
                ) {
                  grpRecordAdd('cmsrpt', grid, err_msg);
                }
              }}
            />
          )}
        </>
      );
    },
    CheckboxRenderer: (cellInfo) => {
      const grid = useSelector(
        (state) => state?.sharedState?.MaintainRebateReducer?.group_data
      );
      const err = useSelector(
        (state) => state?.sharedState?.MaintainRebateReducer?.err_msg
      );
      const disableCnd =
        !cellInfo.data.newFlag &&
        cellInfo.data.startQtr &&
        !cellInfo.data.startQtrErr &&
        cms_freeze_qtr &&
        !compareQtrs(cellInfo.data.startQtr, cms_freeze_qtr);
      return (
        // <div className="tbl-checkbox">
        //   <FormControlLabel
        //     control={<Checkbox color="primary" />}
        //     value={cellInfo.data.delete}
        //     onChange={(e, val) => {
        //       let ind = cellInfo.node.rowIndex;
        //       groupChangehandler(val, 'delete', ind, 'cmsrpt', grid);
        //     }}
        //     checked={cellInfo.data.delete}
        //   />
        // </div>
        <>
          <OverlayTrigger
            placement="bottom"
            overlay={<Tooltip id="add-tooltip">Add</Tooltip>}
          >
            <Button
              className="frr-box-shadow-none"
              data-testid=""
              aria-label="Add Update URA from Payments"
              variant="text"
              onClick={() => grpRecordAdd('cmsrpt', grid, err)}
              disabled={!isEnablebyRole}
            >
              <SVGComponent iconName="Icon-addCircle" />{' '}
            </Button>
          </OverlayTrigger>
          <OverlayTrigger
            placement="bottom"
            overlay={
              disableCnd ? (
                <Tooltip>
                  CMS reporting group record cannot be deleted since the group
                  is used. Please use End quarter instead
                </Tooltip>
              ) : (
                <Tooltip>Delete</Tooltip>
              )
            }
          >
            <span>
              <Button
                className="th-ic trash-blue frr-box-shadow-none"
                variant="text"
                aria-label="Trash"
                onClick={() => {
                  setDeleteModal(true);
                  setDeleteInd({ table: 'cmsrpt', grid: grid, data: cellInfo });
                }}
                disabled={disableCnd || !isEnablebyRole}
              >
                <SVGComponent iconName="Icon-delete" />
              </Button>
            </span>
          </OverlayTrigger>
        </>
      );
    },
  };

  const cmsUtilFrameworkComponents = {
    TextBoxRenderer: (cellInfo) => {
      const grid = useSelector(
        (state) => state?.sharedState?.MaintainRebateReducer?.group_data
      );
      const err_msg = useSelector(
        (state) => state?.sharedState?.MaintainRebateReducer?.err_msg
      );
      const onchange = (e, data, blur) => {
        let obj;
        const va = e.target.value;
        const cid = data.column.colId;
        if (!blur)
          obj = qtrHandler(va, data, false, grid, err_msg, 'cmsutil', cid);
        else
          obj = qtrHandler(
            va,
            data,
            true,
            grid,
            err_msg,
            'cmsutil',
            cid,
            true,
            cms_freeze_qtr
          );
        dispatch({
          type: actionType.GROUP_GRID_DATA,
          payload: obj.tabdata,
        });
        if (!blur) makeItDirty();
        else dispatch(errorMsg([...new Set([...obj.err])]));
        data.api.refreshCells();
      };
      const fldChange = (e, cellInfo, fld, blur) => {
        const ind = cellInfo.node.rowIndex;
        const val = e.target.value;
        groupChangehandler(val, fld, ind, 'cmsutil', grid, blur, err_msg);
      };
      const disableFld =
        !cellInfo.data.newFlag &&
        cellInfo.data.startQtr &&
        !cellInfo.data.startQtrErr &&
        cms_freeze_qtr &&
        !compareQtrs(cellInfo.data.startQtr, cms_freeze_qtr);
      return (
        <>
          {cellInfo.column.colId === 'startQtr' && (
            <TextField
              className={
                cellInfo.data?.startQtrErr
                  ? 'td-active-cell tBill-validate'
                  : ''
              }
              InputLabelProps={{ shrink: true }}
              inputProps={{ maxLength: 6 }}
              value={cellInfo.data.startQtr}
              onChange={(e) => onchange(e, cellInfo, false)}
              onBlur={(e) => onchange(e, cellInfo, true)}
              disabled={disableFld || !isEnablebyRole}
            />
          )}
          {cellInfo.column.colId === 'endQtr' && (
            <OverlayTrigger
              placement="bottom"
              overlay={
                <Tooltip style={disableFld ? {} : { opacity: 0 }}>
                  CMS Utilization group record cannot be updated since the group
                  is used. Please use End quarter instead
                </Tooltip>
              }
            >
              <TextField
                className={
                  cellInfo.data?.endQtrErr
                    ? 'td-active-cell tBill-validate'
                    : ''
                }
                inputProps={{ maxLength: 6 }}
                InputLabelProps={{ shrink: true }}
                value={cellInfo.data.endQtr}
                onChange={(e) => onchange(e, cellInfo, false)}
                onBlur={(e) => onchange(e, cellInfo, true)}
                disabled={!isEnablebyRole}
              />
            </OverlayTrigger>
          )}
          {cellInfo.column.colId === 'cmsUtilGroupNum' && (
            <TextField
              InputLabelProps={{ shrink: true }}
              value={cellInfo.data.cmsUtilGroupNum}
              className={
                cellInfo.data?.cmsUtilGroupNumErr
                  ? 'td-active-cell tBill-validate'
                  : ''
              }
              inputProps={{ maxLength: 2 }}
              onChange={(e) => fldChange(e, cellInfo, 'cmsUtilGroupNum', false)}
              onBlur={(e) => fldChange(e, cellInfo, 'cmsUtilGroupNum', true)}
              disabled={disableFld || !isEnablebyRole}
            />
          )}
          {cellInfo.column.colId === 'cmsUtilGroupName' && (
            <TextField
              InputLabelProps={{ shrink: true }}
              inputProps={{ maxLength: 60 }}
              value={cellInfo.data.cmsUtilGroupName}
              className={
                cellInfo.data?.cmsUtilGroupNameErr
                  ? 'td-active-cell tBill-validate'
                  : ''
              }
              onChange={(e) =>
                fldChange(e, cellInfo, 'cmsUtilGroupName', false)
              }
              onBlur={(e) => fldChange(e, cellInfo, 'cmsUtilGroupName', true)}
              disabled={disableFld || !isEnablebyRole}
              onKeyDown={(e) => {
                if (
                  ((e.key === 'Tab' && !e.shiftKey) ||
                    e.key === 'ArrowRight') &&
                  grid.cmsUtilization.length === cellInfo.rowIndex + 1
                ) {
                  grpRecordAdd('cmsutil', grid, err_msg);
                }
              }}
            />
          )}
        </>
      );
    },
    CheckboxRenderer: (cellInfo) => {
      const grid = useSelector(
        (state) => state?.sharedState?.MaintainRebateReducer?.group_data
      );
      const err = useSelector(
        (state) => state?.sharedState?.MaintainRebateReducer?.err_msg
      );
      const disableCnd =
        !cellInfo.data.newFlag &&
        cellInfo.data.startQtr &&
        !cellInfo.data.startQtrErr &&
        cms_freeze_qtr &&
        !compareQtrs(cellInfo.data.startQtr, cms_freeze_qtr);
      return (
        // <div className="tbl-checkbox">
        //   <FormControlLabel
        //     control={<Checkbox color="primary" />}
        //     value={cellInfo.data.delete}
        //     onChange={(e, val) => {
        //       let ind = cellInfo.node.rowIndex;
        //       groupChangehandler(val, 'delete', ind, 'cmsutil', grid);
        //     }}
        //     checked={cellInfo.data.delete}
        //   />
        // </div>
        <>
          <OverlayTrigger
            placement="bottom"
            overlay={<Tooltip id="add-tooltip">Add</Tooltip>}
          >
            <Button
              className="frr-box-shadow-none"
              data-testid=""
              aria-label="Add Update URA from Payments"
              variant="text"
              onClick={() => grpRecordAdd('cmsutil', grid, err)}
              disabled={!isEnablebyRole}
            >
              <SVGComponent iconName="Icon-addCircle" />{' '}
            </Button>
          </OverlayTrigger>
          <OverlayTrigger
            placement="bottom"
            overlay={
              disableCnd ? (
                <Tooltip>
                  CMS Utilization group record cannot be deleted since the group
                  is used. Please use End quarter instead
                </Tooltip>
              ) : (
                <Tooltip>Delete</Tooltip>
              )
            }
          >
            <span className="d-inline-block">
              <Button
                style={disableCnd ? { pointerEvents: 'none' } : {}}
                className="th-ic trash-blue frr-box-shadow-none"
                variant="text"
                aria-label="Trash"
                data-test="deletePopup"
                onClick={() => {
                  setDeleteModal(true);
                  setDeleteInd({
                    table: 'cmsutil',
                    grid: grid,
                    data: cellInfo,
                  });
                }}
                disabled={disableCnd || !isEnablebyRole}
              >
                <SVGComponent iconName="Icon-delete" />
              </Button>
            </span>
          </OverlayTrigger>
        </>
      );
    },
  };

  const enrollFrameworkComponents = {
    TextBoxRenderer: (cellInfo) => {
      const grid = useSelector(
        (state) => state?.sharedState?.MaintainRebateReducer?.enroll_data
      );
      const err = useSelector(
        (state) => state?.sharedState?.MaintainRebateReducer?.err_msg
      );
      const mx = useSelector(
        (state) => state?.sharedState?.MaintainRebateReducer?.max_enroll_qtr
      );
      const disableFld =
        !cellInfo.data.newFlag &&
        cellInfo.data.qtr &&
        !cellInfo.data.qtrErr &&
        mx &&
        !compareQtrs(cellInfo.data.qtr, mx);
      return (
        <>
          {cellInfo.column.colId === 'qtr' && (
            <OverlayTrigger
              placement="bottom"
              overlay={
                <Tooltip style={disableFld ? {} : { opacity: 0 }}>
                  Enrollment record cannot be updated since the enrollment
                  record is used
                </Tooltip>
              }
            >
              <TextField
                className={
                  cellInfo.data?.qtrErr ? 'td-active-cell tBill-validate' : ''
                }
                InputLabelProps={{ shrink: true }}
                value={cellInfo.data.qtr || ''}
                onChange={(e) => {
                  const val = e.target.value;
                  const da = cellInfo;
                  const data = qtrHandler(
                    val,
                    da,
                    false,
                    grid,
                    err,
                    'roll',
                    'qtr'
                  );
                  dispatch({
                    type: actionType.ENROLL_GRID_DATA,
                    payload: data.tabdata,
                  });
                  makeItDirty();
                  cellInfo.api.refreshCells();
                }}
                inputProps={{ maxLength:6 }}
                onBlur={(e) => {
                  setSaveMsg([]);
                  const v = e.target.value;
                  const d = cellInfo;
                  const data = qtrHandler(
                    v,
                    d,
                    true,
                    grid,
                    err,
                    'roll',
                    'qtr',
                    mx
                  );
                  dispatch({
                    type: actionType.ENROLL_GRID_DATA,
                    payload: data.tabdata,
                  });
                  dispatch(errorMsg([...new Set([...data.err])]));
                  cellInfo.api.refreshCells();
                }}
                disabled={disableFld || !isEnablebyRole}
              />
            </OverlayTrigger>
          )}
          {cellInfo.column.colId === 'numOfLives' && (
            <TextField
              InputLabelProps={{ shrink: true }}
              inputProps={{
                maxLength: 15,
                id: 'numOfLives',
              }}
              value={cellInfo.data.numOfLives}
              onChange={(e) => {
                const ind = cellInfo.node.rowIndex;
                const { value } = e.target;
                enrollChangehandler(value, 'numOfLives', ind, grid);
                cellInfo.api.refreshCells();
              }}
              disabled={disableFld || !isEnablebyRole}
            />
          )}
        </>
      );
    },
    DropdownRenderer: (cellInfo) => {
      const enroll_time = useSelector(
        (state) => state?.sharedState?.RebatePgmReducer?.enroll_time
      );
      const grid = useSelector(
        (state) => state?.sharedState?.MaintainRebateReducer?.enroll_data
      );
      const err = useSelector(
        (state) => state?.sharedState?.MaintainRebateReducer?.err_msg
      );
      const disableFld =
        !cellInfo.data.newFlag &&
        cellInfo.data.qtr &&
        !cellInfo.data.qtrErr &&
        max_enroll_qtr &&
        !compareQtrs(cellInfo.data.qtr, max_enroll_qtr);
      return (
        <TextField
          style={{ width: '150px' }}
          className={
            cellInfo.data?.timingcdErr ? 'td-active-cell tBill-validate' : ''
          }
          InputLabelProps={{ shrink: true }}
          value={cellInfo.data.enrollmentTimingCd || ''}
          select
          onChange={(e) => {
            const ind = cellInfo.node.rowIndex;
            const { value } = e.target;
            enrollChangehandler(value, 'enrollmentTimingCd', ind, grid, err);
            cellInfo.api.refreshCells();
          }}
          disabled={disableFld || !isEnablebyRole}
        >
          <MenuItem className="frr-dropdown-blank-item" key="" value="-1" />
          {enroll_time &&
            enroll_time.map((item, ind) => (
              <MenuItem key={ind} value={item.codeValueID.codeValue}>
                {item.codeValueID.codeValue}: {item.shortDescription}
              </MenuItem>
            ))}
        </TextField>
      );
    },
    CheckboxRenderer: (cellInfo) => {
      const grid = useSelector(
        (state) => state?.sharedState?.MaintainRebateReducer?.enroll_data
      );
      const err = useSelector(
        (state) => state?.sharedState?.MaintainRebateReducer?.err_msg
      );
      const disableFld =
        !cellInfo.data.newFlag &&
        cellInfo.data.qtr &&
        !cellInfo.data.qtrErr &&
        max_enroll_qtr &&
        !compareQtrs(cellInfo.data.qtr, max_enroll_qtr);
      return (
        // <div className="tbl-checkbox">
        //   <FormControlLabel
        //     control={<Checkbox color="primary" />}
        //     value={cellInfo.data.delete || false}
        //     onChange={(e, val) => {
        //       let ind = cellInfo.node.rowIndex;
        //       enrollChangehandler(val, 'delete', ind, grid);
        //       cellInfo.api.refreshCells();
        //     }}
        //     checked={cellInfo.data.delete || false}
        //   />
        // </div>
        <>
          <OverlayTrigger
            placement="bottom"
            overlay={<Tooltip id="add-tooltip">Add</Tooltip>}
          >
            <Button
              className="frr-box-shadow-none"
              data-testid="add-enroll"
              aria-label="Add Update URA from Payments"
              variant="text"
              onClick={() => enrollRecordAdd(grid, err)}
              disabled={!isEnablebyRole}
            >
              <SVGComponent iconName="Icon-addCircle" />{' '}
            </Button>
          </OverlayTrigger>
          <OverlayTrigger
            placement="bottom"
            overlay={
              disableFld ? (
                <Tooltip>
                  Enrollment record cannot be deleted since the enrollment
                  record is used
                </Tooltip>
              ) : (
                <Tooltip>Delete</Tooltip>
              )
            }
          >
            <span>
              <Button
                className="th-ic trash-blue frr-box-shadow-none"
                variant="text"
                aria-label="Trash"
                data-test="deletePopup"
                onClick={() => {
                  setDeleteModal(true);
                  setDeleteInd({ table: 'enroll', grid: grid, data: cellInfo });
                }}
                disabled={disableFld || !isEnablebyRole}
              >
                <SVGComponent iconName="Icon-delete" />
              </Button>
            </span>
          </OverlayTrigger>
        </>
      );
    },
    CommentsRenderer: (cellInfo) => {
      const disableFld =
        !cellInfo.data.newFlag &&
        cellInfo.data.qtr &&
        !cellInfo.data.qtrErr &&
        max_enroll_qtr &&
        !compareQtrs(cellInfo.data.qtr, max_enroll_qtr);
      const grid = useSelector(
        (state) => state?.sharedState?.MaintainRebateReducer?.enroll_data
      );
      const err = useSelector(
        (state) => state?.sharedState?.MaintainRebateReducer?.err_msg
      );
      return (
        <div className="tdCell frr-icon-btn-group d-flex justify-content-start">
          <OverlayTrigger
            placement="bottom"
            overlay={<Tooltip id="com-tooltip">Comment</Tooltip>}
          >
            {!cellInfo.data.newFlag ? (
              <Button
                onClick={() =>
                  commentsData(true, 'RPC_ENROLLMENT', cellInfo.data.corrLinkID)
                }
                variant="text"
                disabled={disableFld}
                onKeyDown={(e) => {
                  // if (
                  //   (e.key === 'Tab' && !e.shiftKey) ||
                  //   e.key === 'ArrowRight'
                  // ) {
                  //   enrollRecordAdd(grid, err);
                  // }
                }}
              >
                <img
                  alt="comment"
                  src={
                    cellInfo.data.cc_COMMENTS_EXIST
                      ? CommentVisibleIcon
                      : CommentIcon
                  }
                />
              </Button>
            ) : (
              <Button
                disabled
                type="button"
                aria-label="comment"
                className="th-ic comment-ic frr-disabled-comment-btn"
                variant="text"
              >
                <img alt="comment" src={CommentIcon} />
              </Button>
            )}
          </OverlayTrigger>
        </div>
      );
    },
  };

  const recursive = async (data, ind, newval, copy) => {
    if (ind < data.length) {
      const obj = data[ind];
      const result = await dispatch(getExistingCorrLinkIds([obj.corrLinkID]));
      obj.cc_COMMENTS_EXIST = result?.data?.length ? 1 : 0;
      newval.push(obj);
      recursive(data, ind + 1, newval);
    }
    if (ind === data.length) {
      dispatch({ type: actionType.ENROLL_GRID_DATA, payload: newval });
      if (copy)
        dispatch({
          type: actionType.COPY_ENROLL_GRID_DATA,
          payload: JSON.stringify(data),
        });
    }
  };

  const commentsData = (status, table, corrLinkId) => {
    setShowComments(status);
    setLinkTable(table);
    setCorrLinkId(corrLinkId);
  };

  const [localStoreFlag, setLocalStoreFlag] = React.useState(false);
  const wasDirtyRef = React.useRef(save_disable === false);

  React.useEffect(() => {
    const isDirty = save_disable === false;
    if (
      !wasDirtyRef.current &&
      isDirty &&
      Array.isArray(saveMsg) &&
      saveMsg.length > 0
    ) {
      setSaveMsg([]);
    }
    wasDirtyRef.current = isDirty;
  }, [save_disable, saveMsg]);

  React.useEffect(() => {
    if (kcRoles?.userPrivileges.length > 0) {
      setHasAccess(
        checkActionAccessByRole(
          process.env.REACT_APP_HIDE_ACCESS_ROLES,
          kcRoles
        )
      );
      setIsEnablebyRole(
        checkActionAccessByRole(process.env.REACT_APP_STATE_ONLY_ROLE, kcRoles)
      );
    }
  }, []);

  React.useEffect(() => {
    if (
      enroll_data &&
      localStorage.getItem('viewpgmdetails') &&
      localStoreFlag
    ) {
      localStorage.removeItem('viewpgmdetails');
      setLocalStoreFlag(false);
      recursive(enroll_data, 0, [], true);
    }
    if (enroll_data) {
      let err = [
        ...enroll_data.filter((o) => o.qtrMsg),
        ...enroll_data.filter((o) => o.timingcdMsg),
      ];
      err = err.length > 0;
      setEnrollErr(err);
    }
  }, [enroll_data]);

  React.useEffect(() => {
    if (ura_grid_data) {
      let srcerr = ura_grid_data.rpcUraSource.filter((o) => o.startQtrMsg);
      srcerr = srcerr.length > 0;
      setUraSrcErr(srcerr);
      let calcerr = [
        ...ura_grid_data.rpcUraCal.filter((o) => o.effectiveQtrMsg),
        ...ura_grid_data.rpcUraCal.filter((o) => o.calcMethodCdMsg),
        ...ura_grid_data.rpcUraCal.filter((o) => o.calcGenericPctMsg),
        ...ura_grid_data.rpcUraCal.filter((o) => o.calcFixedPctMsg),
      ];
      calcerr = calcerr.length > 0;
      setUraCalcErr(calcerr);
      let payerr = ura_grid_data.rpcUrPayment.filter((o) => o.startQtrMsg);
      payerr = payerr.length > 0;
      setUraPayErr(payerr);

      // Get laser qtr from ura source
      if (ura_grid_data?.rpcUraSource.length > 0) {
        const laserQtr = _.minBy(ura_grid_data.rpcUraSource, (o) => {
          return checkQuarterValidation(o.startQtr) &&
            o.rpcParamValue === 'CALC'
            ? new Date(convertQuaterToDate(o.startQtr))
            : null;
        });

        dispatch({
          type: actionType.LAST_URA_SRC_CALC_QTR,
          payload: laserQtr?.startQtr || '',
        });
      }
    }
  }, [ura_grid_data]);

  React.useEffect(() => {
    if (int_grid_data) {
      let srcerr = [
        ...int_grid_data.rpcParamVoIntShareIntCalList.filter(
          (o) => o.effectiveQtrMsg
        ),
        ...int_grid_data.rpcParamVoIntShareIntCalList.filter(
          (o) => o.calcMethodCdMsg
        ),
        ...int_grid_data.rpcParamVoIntShareIntCalList.filter(
          (o) => o.calcFixedPctMsg
        ),
      ];
      srcerr = srcerr.length > 0;
      setIntCalErr(srcerr);
      let calcerr = [
        ...int_grid_data.rpcCalcPctVOIntShareFedaralList.filter(
          (o) => o.startQtrMsg
        ),
        ...int_grid_data.rpcCalcPctVOIntShareFedaralList.filter(
          (o) => o.rpcParamValueMsg
        ),
      ];
      calcerr = calcerr.length > 0;
      setIntFedErr(calcerr);
      let payerr = [
        ...int_grid_data.rpcParamVoIntShareFedaralFamiliList.filter(
          (o) => o.startQtrMsg
        ),
        ...int_grid_data.rpcParamVoIntShareFedaralFamiliList.filter(
          (o) => o.rpcParamValueMsg
        ),
      ];
      payerr = payerr.length > 0;
      setIntFmlyErr(payerr);
    }
  }, [int_grid_data]);

  React.useEffect(() => {
    if (group_data) {
      let srcerr = [
        ...group_data.cmsReporting.filter((o) => o.startQtrMsg),
        ...group_data.cmsReporting.filter((o) => o.endQtrMsg),
        ...group_data.cmsReporting.filter((o) => o.cmsRptGroupNumMsg),
        ...group_data.cmsReporting.filter((o) => o.cmsRptGroupNameMsg),
        ...group_data.cmsReporting.filter((o) => o.cmsRptTitleMsg),
      ];
      srcerr = srcerr.length > 0;
      setCmsRptErr(srcerr);
      let calcerr = [
        ...group_data.cmsUtilization.filter((o) => o.startQtrMsg),
        ...group_data.cmsUtilization.filter((o) => o.endQtrMsg),
        ...group_data.cmsUtilization.filter((o) => o.cmsUtilGroupNumMsg),
        ...group_data.cmsUtilization.filter((o) => o.cmsUtilGroupNameMsg),
      ];
      calcerr = calcerr.length > 0;
      setCmsUtilErr(calcerr);
    }
  }, [group_data]);

  React.useEffect(() => {
    if (def_override) {
      let data = { ...pgm_detail, ...def_override };
      if (data?.useDefSystemInd)
        data = mergeSysDefOverrides(data, 1, sys_override, {});
      dispatch(pgmDetail(data));
      dispatch(copyData(JSON.stringify(data)));
    }
  }, [def_override]);

  React.useEffect(() => {
    if (audit_grid_data) {
      if (default_audit) {
        const aud = defaultDataForAudits(def_sys_aud, unit_type, true);
        dispatch({ type: actionType.CONS_AUDIT_DATA, payload: aud.audit });
        dispatch({
          type: actionType.UNIT_TYPE_AUDIT_GRID_DATA,
          payload: aud.unitData,
        });
      } else if (!default_audit && pgm_detail?.planTypeCd === 'SUPP') {
        const data = auditTabDataCons(audit_grid_data);
        dispatch({ type: actionType.CONS_AUDIT_DATA, payload: data });
      } else {
        const data = auditTabDataCons(audit_grid_data);
        dispatch({ type: actionType.CONS_AUDIT_DATA, payload: data });
        dispatch({
          type: actionType.COPY_AUDIT_GRID_DATA,
          payload: JSON.stringify(data),
        });
      }
    }
  }, [audit_grid_data]);

  React.useEffect(() => {
    if (default_audit && pgm_detail.planTypeCd === 'SUPP') {
      const aud = defaultDataForAudits(def_sys_aud, unit_type, true);
      dispatch({ type: actionType.CONS_AUDIT_DATA, payload: aud.audit });
      dispatch({
        type: actionType.UNIT_TYPE_AUDIT_GRID_DATA,
        payload: aud.unitData,
      });
    } else if (
      !default_audit &&
      pgm_detail?.planTypeCd === 'SUPP' &&
      pgm_detail?.claimRebateProgramCd
    ) {
      dispatch(getAuditGridList(pgm_detail.claimRebateProgramCd));
      dispatch(getUnitTypeAuditGridList(pgm_detail.claimRebateProgramCd));
    }
  }, [default_audit, pgm_detail?.claimRebateProgramCd]);

  const updateValues = async (pgm_detail, saved) => {
    if (saved) {
      let updatePayload = {
        ...uraPmryPayload(
          ura_grid_data,
          copy_ura_data,
          pgm_detail.rebateProgramCd,
          logInUser
        ),
        ...intPmryPayload(
          int_grid_data,
          copy_int_data,
          pgm_detail.rebateProgramCd,
          logInUser
        ),
        ...grpPmryPayload(
          group_data,
          copy_group_data,
          pgm_detail.rebateProgramCd,
          logInUser
        ),
      };
      if (pgm_detail.planTypeCd === 'SUPP') {
        updatePayload = {
          ...updatePayload,
          ...enrollPmryPayload(
            enroll_data,
            copy_enroll_data,
            pgm_detail.rebateProgramCd,
            logInUser
          ),
        };
      }
      await dispatch(saveUpdateRebatePgm(updatePayload));
    }
    dispatch(customReset());
    dispatch(copyData(JSON.stringify(pgm_detail)));
    dispatch(getLastFrozenQtr(pgm_detail.rebateProgramCd));
    dispatch(getUraGridList(pgm_detail.rebateProgramCd));
    dispatch(getIntGridList(pgm_detail.rebateProgramCd));
    if (pgm_detail.useDefAuditsInd) {
      const aud = defaultDataForAudits(def_sys_aud, unit_type, true);
      dispatch({ type: actionType.CONS_AUDIT_DATA, payload: aud.audit });
      dispatch({
        type: actionType.UNIT_TYPE_AUDIT_GRID_DATA,
        payload: aud.unitData,
      });
      dispatch({
        type: actionType.COPY_AUDIT_GRID_DATA,
        payload: JSON.stringify(aud.audit),
      });
      dispatch({
        type: actionType.COPY_UNIT_TYPE_DATA,
        payload: JSON.stringify(aud.unitData),
      });
    } else if (pgm_detail.planTypeCd !== 'SUPP') {
      dispatch(getAuditGridList(pgm_detail.rebateProgramCd));
      dispatch(getUnitTypeAuditGridList(pgm_detail.rebateProgramCd));
    }
    dispatch(getGroupGridData(pgm_detail.rebateProgramCd));
    dispatch(getCmsFreezeQtr(pgm_detail.rebateProgramCd));
    dispatch(getMaxQtrEnroll(pgm_detail.rebateProgramCd));
    const payload = {
      planTypeCd: pgm_detail.planTypeCd,
      rebateProgramCd: pgm_detail.rebateProgramCd,
    };
    dispatch(getOverrideDefaultData(payload));
    if (!sys_override) dispatch(getOverrideSystemData({}));
    if (pgm_detail.planTypeCd === 'SUPP' || pgm_detail.planTypeCd === 'COMM') {
      setLocalStoreFlag(true);
      dispatch(getEnrollGridData(pgm_detail.rebateProgramCd));
    }

    if (pgm_detail.planTypeCd === 'SUPP' && pgm_detail.claimRebateProgramCode)
      dispatch(getUseDefAuditsInd(pgm_detail.claimRebateProgramCode));

    const value = pgm_detail.useDefAuditsInd === 1;
    dispatch(defaultAuditCheck(value));
    if (pgm_detail.planTypeCd !== 'SUPP' || pgm_detail.planTypeCd !== 'COMM')
      localStorage.removeItem('viewpgmdetails');
  };

  const handleViewHistory = () => {
    setShowViewHistory(true);
    setKeyValue({
      REBATE_PROGRAM_CD: pgm_detail.rebateProgramCd,
      // STUB_INV_SEQ_NUM: 0,
      // USE_MCO_SERVICE_DT_IND: 0,
    });
  };

  React.useEffect(() => {
    if (save_info) {
      if (save_info.message === 'SUCESS' && save_info.status === '001') {
        setLoad(false);
        if (closeFlag) closeTab(Constants.MAINTAIN_ROUTE, history);
        makeFormDirty(Constants.MAINTAIN_ROUTE, false);
        dispatch(saveEnable(true));
        dispatch(errorMsg([]));
        dispatch(fieldErr({}));
        updateValues(pgm_detail, true);
        setSaveMsg([SUCCESSMESSAGE_PRICE]);
        // waitinggg(2000);
        // setTimeout(() => {
        //setSaveMsg([]);
        dispatch({ type: actionType.SAVE_INFO, payload: null });
        // }, 5000);
      }
    }
  }, [save_info]);

  const waitinggg = (ms) => {
    new Promise((resolve) => {
      const start = performance.now();
      const frame = (now) => {
        if (now - start >= ms) {
          resolve();
        } else {
          requestAnimationFrame(frame);
        }
      };
      requestAnimationFrame(frame);
    });
  };

  React.useEffect(() => {
    setLoad(false);
    if (localStorage.getItem('viewpgmdetails')) {
      dispatch(tabValue('one'));
      // dispatch(customReset());
      if (pgm_detail?.corrLinkId)
        dispatch(getExistingCorrLinkIds([pgm_detail.corrLinkId], 'maintain'));
      // dispatch(copyData(JSON.stringify(pgm_detail)));
      // dispatch(getLastFrozenQtr(pgm_detail.rebateProgramCd));
      // dispatch(getUraGridList(pgm_detail.rebateProgramCd));
      // dispatch(getIntGridList(pgm_detail.rebateProgramCd));
      // dispatch(getAuditGridList(pgm_detail.rebateProgramCd));
      // dispatch(getUnitTypeAuditGridList(pgm_detail.rebateProgramCd));
      // dispatch(getGroupGridData(pgm_detail.rebateProgramCd));
      // dispatch(getCmsFreezeQtr(pgm_detail.rebateProgramCd));
      // dispatch(getMaxQtrEnroll(pgm_detail.rebateProgramCd));
      // let payload = {
      //   planTypeCd: pgm_detail.planTypeCd,
      //   rebateProgramCd: pgm_detail.rebateProgramCd,
      // };
      // dispatch(getOverrideDefaultData(payload));
      // if (!sys_override) dispatch(getOverrideSystemData({}));
      // if (pgm_detail.planTypeCd === 'SUPP') {
      //   dispatch(getEnrollGridData(pgm_detail.rebateProgramCd));
      //   if (pgm_detail.claimRebateProgramCode)
      //     dispatch(getUseDefAuditsInd(pgm_detail.claimRebateProgramCode));
      // }
      updateValues(pgm_detail);
    }
  }, [pgm_detail]);

  React.useEffect(() => {
    if (unit_type_data) {
      const err = [
        ...unit_type_data.filter((o) => o.testAmtErr),
        ...unit_type_data.filter((o) => o.mailOrderMultiplierErr),
      ];
      setUnitErr(err.length);
      if (!default_audit && pgm_detail.planTypeCd === 'SUPP') {
        dispatch({
          type: actionType.UNIT_TYPE_AUDIT_GRID_DATA,
          payload: unit_type_data,
        });
      } else if (!default_audit && pgm_detail.planTypeCd !== 'SUPP') {
        dispatch({
          type: actionType.COPY_UNIT_TYPE_DATA,
          payload: JSON.stringify(unit_type_data),
        });
      }
    }
  }, [unit_type_data]);

  React.useEffect(() => {
    const data = JSON.parse(localStorage.getItem('tabItemsData'));
    if (
      data &&
      data.length > 0 &&
      data.filter((x) => {
        return x.navTo === Constants.MAINTAIN_ROUTE && x.isFormSave;
      }).length > 0
    ) {
      const list = data.map((obj) => {
        if (
          obj.navTo === Constants.MAINTAIN_ROUTE &&
          obj.isFormDirty === true
        ) {
          obj.isFormSave = false;
          if (saveValidation()) saveRebateDetails(null, true);
        }
        return obj;
      });
      localStorage.setItem('tabItemsData', JSON.stringify(list));
    }
  }, [JSON.parse(localStorage.getItem('tabItemsData'))]);

  React.useEffect(() => {
    if (err_msg && err_msg.length > 0) {
      tabHighLigther(Constants.MAINTAIN_ROUTE, true);
    } else {
      tabHighLigther(Constants.MAINTAIN_ROUTE, false);
    }
  }, [err_msg]);

  return (
    <div className="tabs-container  tBillPanel" data-testid="MaintainRebate">
      <Spinner load={load} />
      <CustomSeparator parent1="Maintain" parent2="Rebate Program" />
      <DisplaySuccessMessages successMessages={saveMsg} />
      <ErrorMessages errorMessages={err_msg} />
      {!fullScreen && !tabFullSrn && (
        <fieldset className="custom-fieldset" style={{ height: 'auto' }}>
          <div className="row align-items-center">
            <div className="mui-custom-form input-md col-sm-5 col-md-6 col-lg-4">
              <TextField
                id="rebatepgm"
                label="Rebate Program"
                InputLabelProps={{ shrink: true }}
                value={pgm_detail?.rebateProgramCd}
                disabled
              />
            </div>
            <div className="col-sm-4 col-md-4 col-lg-4 pt-4 ">
              <FormControlLabel
                control={<Checkbox color="primary" />}
                label="Use default Audits"
                value={default_audit}
                onChange={(e, val) => {
                  if (val) setConfimPopup(true);
                  else {
                    const data = { ...pgm_detail };
                    data.useDefAuditsInd = 0;
                    dispatch(pgmDetail(data));
                    dispatch(defaultAuditCheck(val));
                  }
                  makeItDirty();
                }}
                disabled={
                  pgm_detail?.planTypeCd === 'COMM' ||
                  pgm_detail?.planTypeCd === 'SUPP' ||
                  !isEnablebyRole
                }
                checked={default_audit}
                data-testid="check-box-change"
              />
            </div>
            {hasAccess && (
              <div className="col-sm-6 col-md-4 col-lg-3 pt-4 pl-sm-4 pl-md-4">
                <div className="comment-sec">
                  Comments{' '}
                  <button
                    type="button"
                    onClick={() =>
                      commentsData(
                        true,
                        'REBATE_PROGRAM_CD',
                        pgm_detail?.corrLinkId
                      )
                    }
                    style={{
                      background: 'none',
                      border: 'none',
                      padding: 0,
                      cursor: 'pointer',
                    }}
                    aria-label="Open comments"
                  >
                    <img
                      src={
                        comment_flag?.length ? CommentVisibleIcon : CommentIcon
                      }
                      alt="comment icon"
                    />
                  </button>
                </div>
              </div>
            )}
          </div>
        </fieldset>
      )}

      {!fullScreen && !tabFullSrn && (
        <div className="row">
          <div className="col-sm-12">
            <div className="float-right mb-3">
              <div className="btn-wrapper mt-3">
                <Button
                  className="btn btn-success btn-search"
                  data-testid="saveValidation"
                  onClick={() => {
                    if (saveValidation()) setSaveView(true);
                  }}
                  disabled={save_disable}
                >
                  <SVGComponent iconName="Icon-awesome-save" /> Save
                </Button>
                <Button
                  className="btn btn-cancel"
                  onClick={() => setCancelView(true)}
                  disabled={save_disable}
                >
                  <SVGComponent iconName="Icon-cancel" /> Cancel
                </Button>
              </div>
            </div>
          </div>
        </div>
      )}
      <div className="col-sm-12 mt-2">
        {!fullScreen && (
          <div className="row align-items-center">
            <div className="frr-custom-rebatePrg-tab-wrap col-sm-12 col-xl-10 mb-4 mt-2">
              <AppBar
                position="static"
                sx={{ width: '100%' }}
                style={{ borderBottom: '1px solid #c9c8c5' }}
              >
                <Tabs
                  value={active_tab}
                  onChange={(ev, val) => dispatch(tabValue(val))}
                  variant="scrollable"
                  scrollButtons="auto"
                  style={{ width: '89%' }}
                >
                  <Tab style={capstyle} value="one" label="Details" />
                  {Object.keys(fld_err).some(
                    (o) =>
                      Constants.DTLS_ERR.indexOf(o) !== -1 &&
                      fld_err[o] === true
                  ) && <span className="tab-error">!</span>}
                  <Tab
                    style={capstyle}
                    value="two"
                    label="Invoice Details"
                    tabIndex={0}
                  />
                  {Object.keys(fld_err).some(
                    (o) =>
                      Constants.INVOICE_ERR.indexOf(o) !== -1 &&
                      fld_err[o] === true
                  ) && <span className="tab-error">!</span>}
                  <Tab
                    style={capstyle}
                    value="three"
                    label="URA"
                    tabIndex={0}
                  />
                  {(uraCalcErr || uraPayErr || uraSrcErr) && (
                    <span className="tab-error">!</span>
                  )}
                  <Tab
                    style={capstyle}
                    value="four"
                    label="Int/Share"
                    tabIndex={0}
                  />
                  {(intCalErr || intFederr || intFmlyErr) && (
                    <span className="tab-error">!</span>
                  )}
                  <Tab
                    style={capstyle}
                    value="five"
                    label="Default/Override"
                    tabIndex={0}
                  />
                  {Object.keys(fld_err).some(
                    (o) =>
                      Constants.OVRD_ERR.indexOf(o) !== -1 &&
                      fld_err[o] === true
                  ) && <span className="tab-error">!</span>}
                  <Tab
                    style={capstyle}
                    value="six"
                    label="Audits"
                    tabIndex={0}
                  />
                  {Object.keys(fld_err).some(
                    (o) =>
                      Constants.AUDIT_ERR.indexOf(o) !== -1 &&
                      fld_err[o] === true
                  ) && <span className="tab-error">!</span>}
                  <Tab
                    style={capstyle}
                    value="seven"
                    label="Unit Type Audits"
                    tabIndex={0}
                  />
                  {unitErr && <span className="tab-error">!</span>}
                  {hasAccess && (
                    <Tab
                      style={capstyle}
                      value="eight"
                      label="Group"
                      tabIndex={0}
                    />
                  )}
                  {(cmsRptErr || cmsUtilErr) && (
                    <span className="tab-error">!</span>
                  )}
                  {(pgm_detail?.planTypeCd === 'SUPP' ||
                    pgm_detail?.planTypeCd === 'COMM') && (
                    <Tab
                      style={capstyle}
                      value="nine"
                      label="Enrollment"
                      tabIndex={0}
                    />
                  )}
                  {enrollErr && <span className="tab-error">!</span>}
                </Tabs>
              </AppBar>
            </div>
            <div className="col-sm-12 col-xl-2 frr-border-bottom justify-content-end">
              <div className="float-sm-right ml-sm-5 mb-sm-2 mb-lg-0 pb-2">
                <div className="float-right th-icon-group ">
                  <div className="d-flex align-items-center ">
                    <OverlayTrigger
                      placement="bottom"
                      overlay={
                        <Tooltip id="history-tooltip">View History</Tooltip>
                      }
                    >
                      <div
                        className="th-icon ic-history"
                        data-testid="viewHistory"
                        onClick={handleViewHistory}
                        tabIndex="0"
                      >
                        <span className="ic-title"> History </span>
                      </div>
                    </OverlayTrigger>
                    <OverlayTrigger
                      placement="bottom"
                      overlay={
                        <Tooltip id="fullScreen-tooltip">
                          {tabFullSrn ? 'Minimize Screen' : 'Full Screen'}
                        </Tooltip>
                      }
                    >
                      <div
                        className={
                          tabFullSrn
                            ? 'th-icon ic-fulScreen-exit'
                            : 'th-icon ic-fulScreen'
                        }
                        role="button"
                        data-testid="setFullScreenView"
                        onClick={() => setTabFullSrn(!tabFullSrn)}
                        tabIndex="0"
                      >
                        <span className="ic-title">
                          {tabFullSrn ? 'Minimize Screen' : 'Full Screen'}
                        </span>
                      </div>
                    </OverlayTrigger>
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}
        {active_tab === 'one' && (
          <DetailsTab
            changeHandler={changeHandler}
            blurHandler={blurHandler}
            flderr={fld_err}
            details={pgm_detail}
            callFrom="maintainRebate"
            isEnablebyRole={isEnablebyRole}
          />
        )}
        {active_tab === 'two' && (
          <InvoiceDetailsTab
            changeHandler={changeHandler}
            blurHandler={blurHandler}
            flderr={fld_err}
            details={pgm_detail}
            isEnablebyRole={isEnablebyRole}
          />
        )}
        {active_tab === 'three' && (
          <URATab
            gridData={ura_grid_data}
            frozenQtr={last_frozen_qtr}
            frameworkComponents={frameworkComponents}
            uraSourceAdd={uraRecordAdd}
            // uraRecordDelete={uraRecordDelete}
            uraCalcFrameworkComponents={uraCalcFrameworkComponents}
            payFrameworkComponent={payFrameworkComponent}
            handleFullScreen={handleFullScreen}
            disableUTAPayAdd={pgm_detail?.planTypeCd === 'FD'}
            isEnablebyRole={isEnablebyRole}
          />
        )}
        {active_tab === 'four' && (
          <IntShareTab
            gridData={int_grid_data}
            frameworkComponents={intCalcFrameworkComponents}
            disableIntCalAdd={pgm_detail?.planTypeCd === 'FD'}
            intRecordAdd={intRecordAdd}
            disableAdd={pgm_detail?.planTypeCd === 'COMM'}
            // intRecordDelete={intRecordDelete}
            intFedaralFrameworkComponents={intFedaralFrameworkComponents}
            intFedFamilyFrameworkComponents={intFedFamilyFrameworkComponents}
            handleFullScreen={handleFullScreen}
            isEnablebyRole={isEnablebyRole}
          />
        )}
        {active_tab === 'five' && (
          <DefaultOverrideTab
            overrideData={override_data}
            changeHandler={changeHandler}
            blurHandler={blurHandler}
            flderr={fld_err}
            details={pgm_detail}
            isEnablebyRole={isEnablebyRole}
          />
        )}
        {active_tab === 'six' && (
          <AuditsTabs
            defAudit={default_audit}
            plan={pgm_detail.planTypeCd}
            data={audit_data}
            flderr={fld_err}
            blurHandler={blurHandler}
            changeHandler={auditchangeHandler}
            isEnablebyRole={isEnablebyRole}
          />
        )}
        {active_tab === 'seven' && (
          <UnitTypeAuditTab
            gridData={unit_type_data}
            frameworkComponents={unitTypeFrameworkComponent}
            handleFullScreen={handleFullScreen}
            isEnablebyRole={isEnablebyRole}
          />
        )}
        {active_tab === 'eight' && (
          <GroupTab
            gridData={group_data}
            cmsReportFrameworkComponents={cmsReportFrameworkComponents}
            cmsUtilFrameworkComponents={cmsUtilFrameworkComponents}
            grpRecordAdd={grpRecordAdd}
            // grpRecordDelete={grpRecordDelete}
            handleFullScreen={handleFullScreen}
            isEnablebyRole={isEnablebyRole}
          />
        )}
        {active_tab === 'nine' &&
          (pgm_detail?.planTypeCd === 'SUPP' ||
            pgm_detail?.planTypeCd === 'COMM') && (
            <EnrollmentTab
              gridData={enroll_data}
              enrollFrameworkComponents={enrollFrameworkComponents}
              // enrollRecordDelete={enrollRecordDelete}
              enrollRecordAdd={enrollRecordAdd}
              gridParamsSet={gridParamsSet}
              handleFullScreen={handleFullScreen}
              isEnablebyRole={isEnablebyRole}
            />
          )}
        <div className="clearfix" />
        <SaveCancelPopup
          open={cancelView}
          title="Cancel"
          data-testid="reset-button-uc"
          onConfim={clearRebateDetails}
          onCancel={(e) => setCancelView(false)}
          moduleName=""
        />
        <SaveCancelPopup
          open={saveView}
          title="Save"
          data-testid="save-api-uc"
          onConfim={saveRebateDetails}
          onCancel={(e) => setSaveView(false)}
          moduleName=""
        />
        {showComments ? (
          <CommentAndCorrespondenceComponent
            setShowComments={async () => {
              if (linkTable === 'REBATE_PROGRAM_CD') {
                dispatch(getExistingCorrLinkIds([corrLinkId], 'maintain'));
              } else {
                const result = await dispatch(
                  getExistingCorrLinkIds([corrLinkId])
                );
                const newVal = enroll_data.map((obj) => {
                  if (obj.corrLinkID === corrLinkId)
                    obj.cc_COMMENTS_EXIST = result?.data?.length ? 1 : 0;
                  return obj;
                });
                dispatch({
                  type: actionType.ENROLL_GRID_DATA,
                  payload: newVal,
                });
                if (enrollParams) enrollParams.api.redrawRows();
              }
              commentsData(false, '', '');
            }}
            linkTableName={linkTable}
            corrLinkId={corrLinkId}
          />
        ) : null}
        {/* <CommonModal
        open={errorPopup}
        className="dialog-420"
        viewAction
        viewHeader
        onOk={() => setErrorPopup(false)}
        okTitle="Ok"
        onClose={() => setErrorPopup(false)}
        modalTitle={Constants.MAINTAIN_REBATE_TITLE}
        childrenComponent={errorMessage}
      /> */}
        <SaveCancelPopup
          open={deleteModal}
          data-testid="cancelPopup"
          title="Delete"
          onConfim={(e) => deleteFromTable()}
          onCancel={(e) => setDeleteModal(false)}
          moduleName=""
        />
        <CommonModal
          open={confimPopup}
          className="dialog-420"
          viewAction
          viewHeader
          onOk={() => {
            setConfimPopup(false);
            const data = { ...pgm_detail };
            data.useDefAuditsInd = 1;
            dispatch(pgmDetail(data));
            dispatch(defaultAuditCheck(true));
            const aud = defaultDataForAudits(def_sys_aud, unit_type, true);
            dispatch({ type: actionType.CONS_AUDIT_DATA, payload: aud.audit });
            dispatch({
              type: actionType.UNIT_TYPE_AUDIT_GRID_DATA,
              payload: aud.unitData,
            });
          }}
          okTitle="Ok"
          onClose={() => setConfimPopup(false)}
          childrenComponent={Constants.USE_DEFAULT_CONFIRM_MSG}
          closeTitle="Cancel"
        />
        {showViewHistory && (
          <ViewHistoryComponent
            setShowViewHistory={setShowViewHistory}
            tableName="REBATE_PROGRAM_CD"
            keyValue={keyValue}
            isSpinner
          />
        )}
      </div>
    </div>
  );
};

export default MaintainRebate;
